import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import commonUtil from './../../../../../../utils/commonUtil';
import HelpTooltip from './components/Tooltip';
import StatementPrintAndDownload from '../../../../../BrowseAndNavigate/AccountSummary/components/StatementPrintAndDownload';
import pdfUtil from '../../../../../../utils/PDFUtil';
import Image from '../../../../../../components/ZUILib/Image';
import InputButton from '../../../../../../components/ZUILib/InputButton';
import ModalPopover from '../../../../../../components/ZUILib/ModalPopover';
import { browserHistory } from 'react-router';
import {
  constDownload,
  constPrint,
  constSendMail,
  eventStatus,
  eventType,
  eventCategory,
} from '../../../../../../utils/clientConstant';
import ValeSystemModal from '../../../../../BrowseAndNavigate/AccountSummary/components/AccountStatus/valeSystemModal';
import TemporaryClosingModal from '../../../../../BrowseAndNavigate/AccountSummary/components/AccountStatus/temporaryClosingModal';
import DownloadPDFWithoutPreview from '../../../../../../components/DownloadPDFWithoutPreview';
import DownloadPDFWithoutPreviewStatement from '../../../../../../components/DownloadPDFWithoutPreview/statementWithHeader';
import GiftListCategories from '../GiftListContent/GiftListCategories';
import { sendMail, getTransferenceOptions, initiateEventCloseProcess, getEventAccountStatementDetails } from '../../../../../BrowseAndNavigate/AccountSummary/actions';
import Tagging from '../../../../../../components/Tagging/Tagging';

const applicationRoutes = commonUtil.getApplicationRoutes();
const pageName = 'accountstatus';

class GiftListSummary extends Component {
  constructor(props) {
    super(props);
    this.eventId = this.props.eventId;
    this.eventOwnerId = this.props.eventInfo && this.props.eventInfo.ownerId;
    this._StartTime = '';
    this._EndTime = '';
    this.AllowedStartTime = '';
    this.AllowedEndTime = '';
    this.isValeSystemDown = false;
    this.eventDaysleft = 0;
    this.state = {
      emailSendStatus: null,
      accountStatementError: null,
      isEmptyGiftRegistry: false,
      eventOwnerId: '',
      initiateEventCloseProcessErrorMessage: null,
      isInitialClosure: true,
    };
  }

  componentDidMount() {
    let ownerId = '';
    if (this.props.eventInfo && this.props.eventInfo.userInfo) {
      this.props.eventInfo.userInfo.forEach((info) => {
        if(info && info.coowner && info.coowner !== "true" && info.hasPermission === true){
          ownerId = info.ownerId;
          return;
        }
      });
    }

    this.setState({ isEmptyGiftRegistry: false, eventOwnerId: ownerId });
  }
  

  gtmEarlyRetirement = () => {};

  onCerrarMesaButtonClick = () => {
    const activeDigitalWallet =
      this.props.user.result.digitalWalletAccNumber !== 'undefined' &&
      this.props.user.result.digitalWalletAccNumber != '' &&
      !_.isEmpty(this.props.user.result.digitalWalletAccNumber)
        ? 'true'
        : 'false';

    getTransferenceOptions(
      this.eventId,
      this.state.eventOwnerId || this.eventOwnerId,
      'closure',
      'false',
      activeDigitalWallet,
    ).then((res) => {
      if (res.body.status.status === 'success') {
        const transferenceData = res.body;
        if (
          (transferenceData.transferenceOptions &&
            +transferenceData.transferenceOptions.bonusAmount <= 0 &&
            +transferenceData.transferenceOptions.transferableAmount <= 0)
        ) {
          this.setState({ isInitialClosure: false });
          this.temporaryClosingModal.handleShow();
        } else {
          this.temporaryClosingModal.handleShow();
        }
      } else {
        this.temporaryClosingModal.handleShow();
      }
    });
  };

  onTemporaryClosingModalAcceptor = () => {
    // redirect to cierre
    this.temporaryClosingModal.handleHide();
    browserHistory.push({
      pathname: commonUtil.getRouteByParameter(
        applicationRoutes.closureTransference,
        {
          eventID: this.eventId,
        },
      ),
      state: {
        eventOwnerId: this.state.eventOwnerId,
        openEvent:
          this.props.eventInfo.eventCategory === eventCategory.OPENEVENT,
      },
    });
  };

  onPartialTransferenceButtonClick = () => {
    if (this.isValeSystemDown) {
      this.valeSystemModal.handleShow();
    } else {
      // redirect to Retiros Anticipados
      this.gtmEarlyRetirement();
      browserHistory.push({
        pathname: commonUtil.getRouteByParameter(
          applicationRoutes.partialTransference,
          { eventID: this.eventId },
        ),
        state: { eventOwnerId: this.state.eventOwnerId },
      });
    }
  };

  UNSAFE_componentWillMount() {
    const accountStatus = this.props.accountStatus;
    this.currentTime = accountStatus?.currTime;
    this._StartTime = commonUtil.formatDate(
      accountStatus?.eventAccountStatementInfo?.transferenceAllowedStartTime,
      'hour12',
    );
    this._EndTime = commonUtil.formatDate(
      accountStatus?.eventAccountStatementInfo?.transferenceAllowedEndTime,
      'hour12',
    );

    this.eventDaysleft = this.getDaysLeft(this.props.eventInfo?.eventDate);
    // this.isValeSystemDown = !accountStatus?.accountSystemAvailable;
  }

  getDaysLeft = (eventDateStr) => {
    const eventDate = new Date(eventDateStr);
    const currentDate = new Date();
  
    eventDate.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);
  
    const diffTime = eventDate - currentDate;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
    return diffDays;
  }

  openTransitModal = () => {
    this.transitModal.handleShow();
  };
  getStatementDetailsForDownload = (isBonusContainerVisible) => {
    this.printDownloadMail(constDownload,isBonusContainerVisible);
  };
  getStatementDetailsForPrint = () => {
    this.printDownloadMail(constPrint);
  };
  getStatementDetailsForSendMail = (isBonusContainerVisible) => {
    this.printDownloadMail(constSendMail,isBonusContainerVisible);
  };
  accountStatementSendMail = (fileName, data) => {
    const emailId =
      !commonUtil.isObjectEmpty(this.props.user) &&
      this.props.user.result &&
      this.props.user.result.emailId;
    sendMail(this.eventId, fileName, data, emailId).then((res) => {
      pdfUtil.contentDownloadedCallback();
      if (res.body.status && res.body.status.status && res.body.status.status === 'success') {
        this.props.showMessagePopUp(true,false,false,commonUtil.getLabel(
          this.props.lables.eventAccountStatement,
          'accountStatement.emailsent.message',
        ));
      } else {
        this.props.showMessagePopUp(false,false,false,commonUtil.getLabel(
          this.props.lables.eventAccountStatement,
          'accountStatement.emailfailed.message',
        ));
      }
    }).catch((e) => {
      pdfUtil.contentDownloadedCallback();
      console.log(e); // console required
    });
  };

  getStatementDetailsForPrintAndDownloadError(data) {
    this.setState({ emailSendStatus: { isSent: false, resMsg: data.error } });
  }

  contentDownloadedCallback = () => {
    ReactDOM.unmountComponentAtNode(ReactDOM.findDOMNode(document.querySelector('#downloadContainer')));
    commonUtil.hideApplicationLoader();

    const channel = commonUtil.getChannel();

    this.props.showMessagePopUp(true,false,false,commonUtil.getLabel(
      this.props.lables.eventAccountStatement,
      'accountStatement.download.success.message',
    ),channel === 'web');
  }

  printDownloadMail = (type,isBonusContainerVisible) => {
    if (type === constSendMail) {
      // const mailContent = (
      //   <DownloadPDFWithoutPreview
      //     pageName={pageName}
      //     printingDate={this.props.printingDate}
      //     download
      //   >
      //     <StatementPrintAndDownload
      //       statementPrintAndDownload={
      //         this.props.statementDetailsForPrintAndDownloadData
      //       }
      //       eventDetailsInfo={this.props.eventInfo}
      //       type={this.downloadPrintType}
      //       accountStatus={this.props.accountStatus}
      //       isBonusContainerVisibleGL={isBonusContainerVisible}
      //     />
      //   </DownloadPDFWithoutPreview>
      // );
      // pdfUtil.attachToDomForMail(
      //   mailContent,
      //   'accountStatement',
      //   this.accountStatementSendMail,
      // );
      this.accountStatementSendMail();
    } else if (type === constDownload) {
      const downloadableContent = (<DownloadPDFWithoutPreviewStatement isMsgGiftListPdf={false} pageName={pageName} printingDate={this.props.printingDate} download>
          <StatementPrintAndDownload
            statementPrintAndDownload={
              this.props.statementDetailsForPrintAndDownloadData
            }
            eventDetailsInfo={this.props.eventInfo}
            type={this.downloadPrintType}
            accountStatus={this.props.accountStatus}
            isBonusContainerVisibleGL={isBonusContainerVisible}
          />
        </DownloadPDFWithoutPreviewStatement>
      );
      pdfUtil.attachToDom(downloadableContent, 'accountstatus_' + this.eventId, this.contentDownloadedCallback);
    } else if (type === constPrint) {
      const printContent = (
        <DownloadPDFWithoutPreview
          pageName={pageName}
          printingDate={this.props.printingDate}
        >
          <StatementPrintAndDownload
            statementPrintAndDownload={
              this.props.statementDetailsForPrintAndDownloadData
            }
            eventDetailsInfo={this.props.eventInfo}
            type={this.downloadPrintType}
            accountStatus={this.props.accountStatus}
          />
        </DownloadPDFWithoutPreview>
      );
      pdfUtil.attachToDomForPrint(printContent, pageName);
    }
  };

  splitPrice = (value) => {
    const str = String(value).trim();
  
    const match = str.match(/^(\D?)([\d,]+)(?:\.(\d+))?$/);
    if (!match) {
      return {
        currency: '$',
        integerWithDot: '0.',
        decimal: '00'
      };
    };
  
    const currency = match[1] || '';
    const rawIntegerPart = match[2].replace(/,/g, '');
    const decimalPart = match[3] || '00';
  
    const formattedInt = Number(rawIntegerPart).toLocaleString();
  
    return {
      currency,
      integerWithDot: formattedInt + '.',
      decimal: decimalPart.padEnd(2, '0')
    };
  }

  handlePopUpCoOwner = (id) => {
    const data = document.querySelector('#' + id);
    if (data.style.display === 'block') {
        data.style.display = 'none';
    } else {
        data.style.display = 'block';
    }
}

  render() {
    const { selectedTheme, statementDetailsForPrintAndDownloadData } = this.props;
    const channel = commonUtil.getChannel();

    const themeColor500 = selectedTheme?.color_500;
    const themeColor50 = selectedTheme?.color_50;
    const themeColor700 = selectedTheme?.color_700;
    const themeColor100 = selectedTheme?.color_100;

    const giftList = [
      {
        name: 'Regalo 1',
        amount: 100,
      },
    ];

    const lables = this.props.lables;
    const itemInfo =
      this?.props?.accountStatus?.eventAccountStatementInfo?.itemsInfo || null;
    const amountInfo =
      this?.props?.accountStatus?.eventAccountStatementInfo?.amountInfo || null;
    const accountData = this.props && this.props.accountStatus && this.props.accountStatus.eventAccountStatementInfo;
    const bonusDetails = statementDetailsForPrintAndDownloadData?.accountStatementInfo?.bonusDetails;
    const statementSummary = statementDetailsForPrintAndDownloadData?.accountStatementInfo?.statementSummary;
    const transferenceInfo = statementDetailsForPrintAndDownloadData?.accountStatementInfo?.transferenceInfo?.transferenceSummary;

    // const isEmployeeEvent = this.props.eventInfo.isEmployeeEvent;
    let eventIconImageURL =
      commonUtil.getAssetURL() + '/images/gifts/gift_bodas.svg';
    const eventTypeForIcon =
      this.props.eventInfo && this.props.eventInfo.eventType
        ? this.props.eventInfo.eventType
        : undefined;


    const datosLink = {
      route: commonUtil.getRouteByParameter(applicationRoutes.eventManagement, {
        pageName: 'DatosDeMiEvento',
        eventID: this.props.eventId,
      }),
    };

    const linkDatosDeEvento = {
      displayName: 'Datos de mi evento',
      route: commonUtil.getRouteByParameter(applicationRoutes.eventManagement, {
        pageName: 'DatosDeMiEvento',
        eventID: this.eventId,
      }),
    };
    const DownloadIcon = {
      route: '',
    };
    const PhysicalJson = {
      displayName: 'Ver detalle',
      route: commonUtil.getRouteByParameter(applicationRoutes.physicalGifts, {
        eventID: this.eventId,
      }),
      onClickHandler: () => {
        if(this.props.handleStatementsPageBackWapState){
          this.props.handleStatementsPageBackWapState(true);
        }
      }
    };

    const PersonalJson = {
      displayName: 'Ver detalle',
      route: commonUtil.getRouteByParameter(
        applicationRoutes.personalPurchases,
        { eventID: this.eventId },
      ),
      onClickHandler: () => {
        if(this.props.handleStatementsPageBackWapState){
          this.props.handleStatementsPageBackWapState(true);
        }
      }
    };
    const ElectronicJson = {
      displayName: 'Ver detalle',
      route: commonUtil.getRouteByParameter(applicationRoutes.electronicsGift, {
        eventID: this.eventId,
      }),
      onClickHandler: () => {
        if(this.props.handleStatementsPageBackWapState){
          this.props.handleStatementsPageBackWapState(true);
        }
      }
    };
    const AccountPartialTransferJson = {
      displayName: 'Ver detalle',
      route: commonUtil.getRouteByParameter(
        applicationRoutes.accountsPartialTransfer,
        { eventID: this.eventId },
      ),
    };
    const BonusDetails = {
      displayName: 'Ver detalle',
      route: commonUtil.getRouteByParameter(applicationRoutes.bonusDetails, {
        eventID: this.eventId,
      }),
    };

    const cerrarMesaButton = {
      type: 'button',
      value: 'Cerrar mi mesa de regalos',
      id: 'CerrarMesa',
      autoFocus: false,
      cssStyle: {
        borderRadius: '4px',
        '--color-500': themeColor500,
      },
      disabled:
        accountData?.enableEventClosure.toString() === 'true' ? '' : 'disabled',
      style:
        accountData?.enableEventClosure.toString() === 'true'
          ? 'btnPrimary btnPrimaryGL size-Full'
          : 'btnPrimary btnPrimaryGL primaryDisabledGL size-Full',
      onClickHandler: this.onCerrarMesaButtonClick,
    };

    const partialTransferenceButton = {
      id: 'partialTransferance',
      type: 'button',
      value: 'Retirar ahora',
      disabled:
        accountData?.enablePartialTransfer.toString() === 'true'
          ? ''
          : 'disabled',
      autoFocus: false,
      cssStyle: {
        '--color-500': themeColor500
      },
      style:
        accountData?.enablePartialTransfer.toString() === 'true'
        ? `${channel === 'web' ? 'gift-summary-withdraw-cancel col-lg-6 col-md-6 col-sm-6' : 'gift-summary-withdraw-cancel-wap border-wap-btn size-Full'}`
        : `${channel === 'web' ? 'gift-summary-withdraw-cancel gift-summary-withdraw-cancel-disabled col-lg-6 col-md-6 col-sm-6' : 'gift-summary-withdraw-cancel-wap border-wap-btn border-wap-btn-disabled size-Full'}`,
      onClickHandler: this.onPartialTransferenceButtonClick,
      onClick: this.gtmEarlyRetirement,
    };

    const emailSendLink = {
      cssClass: 'icon-tache2 closeAlert',
      onClickHandler: () => {
        this.setState({ emailSendStatus: null });
      },
    };
    const accountStatementErrorLink = {
      cssClass: 'icon-tache2 closeAlert',
      onClickHandler: () => {
        this.setState({ accountStatementError: null });
      },
    };

    const inTransitHeaderData = (
      <p>
        {commonUtil.getLabel(
          lables['In transit – Pop up'],
          'accountStatement.intransit.message',
        )}
      </p>
    );

    const webCloseModal = {
      backgroundColor: '#F5F5F5',
      padding: '10px 15px',
      borderRadius: '12px 12px 0 0',
    };

    const webCloseBtn = {
      backgroundColor: 'transparent',
    };

    const webCloseSpan = {
      color: '#666666',
      opacity: 1,
      fontSize: '1.2em',
    };

    const closeSpan = {
      backgroundColor: 'transparent',
      color: '#666666',
      display: 'flex',
      fontSize: '2em',
      fontWeight: '100',
    };

    const modalTitle = {
      color: '#000000',
      fontWeight: 600,
      fontSize: '18px',
    };

    const wapFlexIcons = {
      display: 'flex',
      alignItems: 'center',
    };


    let bonusPercentage = accountData?.bonusPercentage || 0;

    const isBonusContainerVisible = (bonusPercentage != 0) ? true : false;

    let totalPurchasedAmount = amountInfo?.totalPurchasedAmount ? commonUtil.getCurrency(amountInfo.totalPurchasedAmount) : '$0';
    totalPurchasedAmount = this.splitPrice(totalPurchasedAmount);

    let totalBonusAmount = amountInfo?.totalBonusAmount ? commonUtil.getCurrency(amountInfo.totalBonusAmount) : '$0';
    totalBonusAmount = this.splitPrice(totalBonusAmount);

    let bonusDetailTotalBonusAmount = bonusDetails?.totalBonusAmount ? commonUtil.getCurrency(bonusDetails.totalBonusAmount) : '$0';
    bonusDetailTotalBonusAmount = this.splitPrice(bonusDetailTotalBonusAmount);

    let totalBonusEligibleAmount = bonusDetails?.totalBonusEligibleAmount ? commonUtil.getCurrency(bonusDetails?.totalBonusEligibleAmount) : '$0';
    totalBonusEligibleAmount = this.splitPrice(totalBonusEligibleAmount);
    
    let correctTotalAmountEligibleForBonus = statementSummary?.totalAmountEligibleForBonus ? commonUtil.getCurrency(statementSummary?.totalAmountEligibleForBonus) : '$0';
    correctTotalAmountEligibleForBonus = this.splitPrice(correctTotalAmountEligibleForBonus);

     //----electronic amounts----
    let electronicTotalPurchasedAmount = itemInfo?.electronicItemInfo?.totalPurchasedAmount ? commonUtil.getCurrency(itemInfo?.electronicItemInfo.totalPurchasedAmount) : '$0';
    electronicTotalPurchasedAmount = this.splitPrice(electronicTotalPurchasedAmount);

    let electronicTotalAmountEligibleForBonus = statementSummary?.electronicItemInfo?.totalAmountEligibleForBonus ? commonUtil.getCurrency(statementSummary?.electronicItemInfo?.totalAmountEligibleForBonus ) : '$0';
    electronicTotalAmountEligibleForBonus = this.splitPrice(electronicTotalAmountEligibleForBonus);

    let electronicTotalAmountNotEligibleForBonus = statementSummary?.electronicItemInfo?.totalAmountNotEligibleForBonus ? commonUtil.getCurrency(statementSummary?.electronicItemInfo?.totalAmountNotEligibleForBonus) : '$0';
    electronicTotalAmountNotEligibleForBonus = this.splitPrice(electronicTotalAmountNotEligibleForBonus);

    let electronicTotalBonusAmount = statementSummary?.electronicItemInfo?.totalBonusAmount ? commonUtil.getCurrency(statementSummary?.electronicItemInfo?.totalBonusAmount) : '$0';
    electronicTotalBonusAmount = this.splitPrice(electronicTotalBonusAmount);


    //----physical amounts----
    let physicalTotalPurchasedAmount = itemInfo?.physicalItemInfo?.totalPurchasedAmount ? commonUtil.getCurrency(itemInfo?.physicalItemInfo.totalPurchasedAmount) : '$0';
    physicalTotalPurchasedAmount = this.splitPrice(physicalTotalPurchasedAmount);

    let physicalTotalAmountEligibleForBonus = statementSummary?.physicalItemInfo?.totalAmountEligibleForBonus ? commonUtil.getCurrency(statementSummary?.physicalItemInfo?.totalAmountEligibleForBonus) : '$0';
    physicalTotalAmountEligibleForBonus = this.splitPrice(physicalTotalAmountEligibleForBonus);

    let physicalTotalAmountNotEligibleForBonus = statementSummary?.physicalItemInfo?.totalAmountNotEligibleForBonus ? commonUtil.getCurrency(statementSummary?.physicalItemInfo?.totalAmountNotEligibleForBonus) : '$0';
    physicalTotalAmountNotEligibleForBonus = this.splitPrice(physicalTotalAmountNotEligibleForBonus);

    let physicalTotalBonusAmount = statementSummary?.physicalItemInfo?.totalBonusAmount ? commonUtil.getCurrency(statementSummary?.physicalItemInfo?.totalBonusAmount) : '$0';
    physicalTotalBonusAmount = this.splitPrice(physicalTotalBonusAmount);


    //----personal amounts----
    let personalTotalPurchasedAmount = itemInfo?.personalItemInfo?.totalPurchasedAmount ? commonUtil.getCurrency(itemInfo?.personalItemInfo.totalPurchasedAmount) : '$0';
    personalTotalPurchasedAmount = this.splitPrice(personalTotalPurchasedAmount);

    let personalTotalAmountEligibleForBonus = statementSummary?.personalItemInfo?.totalAmountEligibleForBonus ? commonUtil.getCurrency(statementSummary?.personalItemInfo?.totalAmountEligibleForBonus) : '$0';
    personalTotalAmountEligibleForBonus = this.splitPrice(personalTotalAmountEligibleForBonus);

    let personalTotalAmountNotEligibleForBonus = statementSummary?.personalItemInfo?.totalAmountNotEligibleForBonus ? commonUtil.getCurrency(statementSummary?.personalItemInfo?.totalAmountNotEligibleForBonus) : '$0';
    personalTotalAmountNotEligibleForBonus = this.splitPrice(personalTotalAmountNotEligibleForBonus);

    let personalTotalBonusAmount = statementSummary?.personalItemInfo?.totalBonusAmount ? commonUtil.getCurrency(statementSummary?.personalItemInfo?.totalBonusAmount) : '$0';
    personalTotalBonusAmount = this.splitPrice(personalTotalBonusAmount);


    //----transferable amounts----
    let transferableAmount = amountInfo?.transferableAmount ? commonUtil.getCurrency(amountInfo.transferableAmount) : '$0';
    transferableAmount = this.splitPrice(transferableAmount);

    let totalTransferredAmount = transferenceInfo?.totalTransferredAmount ? commonUtil.getCurrency(transferenceInfo.totalTransferredAmount) : '$0';
    totalTransferredAmount = this.splitPrice(totalTransferredAmount);

    let totalBonusLost = transferenceInfo?.totalBonusLost ? commonUtil.getCurrency(transferenceInfo.totalBonusLost) : '$0';
    totalBonusLost = this.splitPrice(totalBonusLost);

    let isEmptyGiftRegistry = false;

    if(totalPurchasedAmount?.integerWithDot == '0.' && electronicTotalPurchasedAmount?.integerWithDot == '0.'){
        isEmptyGiftRegistry = true;
    }

    const noOfDaysLeftLabel = commonUtil.getLabel(
      this.props.lables.eventAccountStatement,
      'accountStatement.gift.table.event.noOfDays.left.text',
    )

    const noOfDaysLeftLabelParts = noOfDaysLeftLabel.split('{0}');

    const initiateEventCloseProcessErrorMessageUI = this.state.initiateEventCloseProcessErrorMessage ? (
      <div className="alertError">
        <i className="icon-tache2" />
        <p>{this.state.initiateEventCloseProcessErrorMessage}</p>
        <a
          className='icon-tache2'
          onClick={() => {
            this.setState({ initiateEventCloseProcessErrorMessage: null });
          }}
        />
      </div>
    ) : null;

    const isAdminProcessStatus = this.props.eventInfo?.eventStatus === eventStatus.ADMINISTRATIVE_PROCESS;

    return (
        <>
        <Tagging ref={(tagging) => (this.tagging = tagging)} />
            {channel === 'web' ?
                <>
                    <div className='gift-summary' >
                    <span className='gift-summary-span'>
                  { (this.props.eventInfo.eventStatus === eventStatus.CLOSED) ?
                   commonUtil.getLabel(
                    this.props.lables.eventAccountStatement,
                    'accountStatement.summary.mesa.de.regalos.cerrada.text'
                   ) :
                  accountData?.eventMessage && accountData?.eventMessage.indexOf('Muchas') > -1
                    ? commonUtil.getLabel(
                      this.props.lables.eventAccountStatement,
                      'accountStatement.summary.mesa.de.regalos.cerrada.text',
                    )
                    : accountData?.enableEventClosure?.toString() === 'true'
                      ? commonUtil.getLabel(
                        this.props.lables.eventAccountStatement,
                        'accountStatement.gift.table.event.close.table.text',
                      )
                      : (this.eventDaysleft <= 0) ? commonUtil.getLabel(
                        this.props.lables.eventAccountStatement,
                        'accountStatement.gift.table.event.close.table.text',
                      ) : <>{noOfDaysLeftLabelParts[0]}
                        <strong>{this.eventDaysleft} días</strong>
                        {noOfDaysLeftLabelParts[1]}</>
                  }
                </span>
                    <div className='gift-summary-icon1'>
                        <svg className={`${isAdminProcessStatus ? 'icon-disabled' : 'cursor-pointer'}`} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          onClick={() => {
                            if (!isAdminProcessStatus) {
                              this.getStatementDetailsForDownload(isBonusContainerVisible);
                            }
                          }}
                        >
                        <path d="M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM17 11L15.59 9.59L13 12.17V4H11V12.17L8.41 9.59L7 11L12 16L17 11Z" fill="#333333"/>
                        </svg>
                        <svg className={`${isAdminProcessStatus ? 'icon-disabled' : 'cursor-pointer'}`} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          onClick={() => {
                            if (!isAdminProcessStatus) {
                              this.getStatementDetailsForSendMail(isBonusContainerVisible);
                            }
                          }}
                        >
                        <path d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 10.99L4 6H20ZM20 18H4V8L12 13L20 8V18Z" fill="#333333"/>
                        </svg>
                    </div>
                    </div>

                    {/* {accountData?.eventMessage &&
                    accountData?.eventMessage.indexOf('Muchas') > -1 && 
                    <div className='gift-summary-congratulation' style={{ backgroundColor: themeColor50 }}>
                    <div className='gift-summary-congratulation-box'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                        <path d="M19.5 9L20.75 6.25L23.5 5L20.75 3.75L19.5 1L18.25 3.75L15.5 5L18.25 6.25L19.5 9ZM12 9.5L9.5 4L7 9.5L1.5 12L7 14.5L9.5 20L12 14.5L17.5 12L12 9.5ZM19.5 15L18.25 17.75L15.5 19L18.25 20.25L19.5 23L20.75 20.25L23.5 19L20.75 17.75L19.5 15Z" fill={themeColor500}/>
                        </svg>

                        <div className='gift-summary-congratulation-text'>
                        <span>{commonUtil.getLabel(
                          this.props.lables.eventAccountStatement,
                          'accountStatement.summary.muchas.felicidades.message',
                        )}
                        </span>
                        </div>
                                        
                    </div>
                    <div className='gift-summary-congratulation-message'>
                        <span>{commonUtil.getLabel(
                          this.props.lables.eventAccountStatement,
                          'accountStatement.muchas.congratulation.message',
                        )}
                        </span>
                    </div>
                    </div>} */}

                    <div className='gift-summary-amount-container'>
                    <div className='gift-summary-amount-container-child col-lg-12 col-md-12 col-sm-12'>
                        <div className='gift-summary-totalamount-box col-lg-5 col-md-5 col-sm-5'>
                        <div className='gift-summary-grand-total'>
                            <div className='gift-summary-grand-total-icon-text' style={{ color: themeColor700 }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M22 12V20C22 20.5304 21.7893 21.0391 21.4142 21.4142C21.0391 21.7893 20.5304 22 20 22H4C3.46957 22 2.96086 21.7893 2.58579 21.4142C2.21071 21.0391 2 20.5304 2 20V12C1.73478 12 1.48043 11.8946 1.29289 11.7071C1.10536 11.5196 1 11.2652 1 11V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H6.17C6.06 5.69 6 5.35 6 5C6 4.20435 6.31607 3.44129 6.87868 2.87868C7.44129 2.31607 8.20435 2 9 2C10 2 10.88 2.5 11.43 3.24V3.23L12 4L12.57 3.23V3.24C13.12 2.5 14 2 15 2C15.7956 2 16.5587 2.31607 17.1213 2.87868C17.6839 3.44129 18 4.20435 18 5C18 5.35 17.94 5.69 17.83 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V11C23 11.2652 22.8946 11.5196 22.7071 11.7071C22.5196 11.8946 22.2652 12 22 12ZM4 20H11V12H4V20ZM20 20V12H13V20H20ZM9 4C8.73478 4 8.48043 4.10536 8.29289 4.29289C8.10536 4.48043 8 4.73478 8 5C8 5.26522 8.10536 5.51957 8.29289 5.70711C8.48043 5.89464 8.73478 6 9 6C9.26522 6 9.51957 5.89464 9.70711 5.70711C9.89464 5.51957 10 5.26522 10 5C10 4.73478 9.89464 4.48043 9.70711 4.29289C9.51957 4.10536 9.26522 4 9 4ZM15 4C14.7348 4 14.4804 4.10536 14.2929 4.29289C14.1054 4.48043 14 4.73478 14 5C14 5.26522 14.1054 5.51957 14.2929 5.70711C14.4804 5.89464 14.7348 6 15 6C15.2652 6 15.5196 5.89464 15.7071 5.70711C15.8946 5.51957 16 5.26522 16 5C16 4.73478 15.8946 4.48043 15.7071 4.29289C15.5196 4.10536 15.2652 4 15 4ZM3 8V10H11V8H3ZM13 8V10H21V8H13Z" fill={themeColor500}/>
                            </svg>
                            <span className='gift-summary-grand-total-text'>   
                            {commonUtil.getLabel(
                              this.props.lables.eventAccountStatement,
                              'accountStatement.summary.grand.total.text',
                            )}           
                            </span>
                            </div>
                            {/* <HelpTooltip isTopToolTip={true} bonusPercentage={bonusPercentage} lables={this.props.lables}/> */}
                            <div className="iconHelp inLine iconHelp-pl iconHelpWrapper">
                                <img src={commonUtil.getAssetURL() + '/images/help.svg'} width={'24'} height={'24'} alt="icon_help" className="icon_help_gl" onClick={() => { this.handlePopUpCoOwner('helpPopup'); }} />
                                <div className="tooltip-backdrop" />
                                <div id="helpPopup" className={`popover bottom bottom-gls ${isBonusContainerVisible ? '' : 'botton-gls-no-bonus'} helpIconCssEmail helpIconEventCss`}>
                                    <div className="arrow" />
                                    <div className="popover-content">
                                        {isBonusContainerVisible ? commonUtil.getLabel(
                                          this.props.lables.eventAccountStatement,
                                          'accountStatement.summary.tooltip.percentage.text',
                                          [bonusPercentage]
                                        ) : commonUtil.getLabel(
                                          this.props.lables.eventAccountStatement,
                                          'accountStatement.summary.tooltip.nobonus.text',
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='gift-summary-total-purchases'>
                            <span className='gift-summary-total-purchases-text'>
                            {commonUtil.getLabel(
                              this.props.lables.eventAccountStatement,
                              'accountStatement.summary.total.purchase.text',
                            )} 
                            </span>
                            <div className='gift-summary-total-purchases-amount'>
                            <div style={{'--color-500': themeColor500}} className='gift-summary-total-purchases-text2'>
                                <span>{totalPurchasedAmount?.currency}</span>
                                <span>{totalPurchasedAmount?.integerWithDot}</span>
                                <span className='gift-summary-total-purchase-text2-decimal'>{totalPurchasedAmount?.decimal}</span>
                            </div>
                            </div>
                            
                        </div>

                        <div className='gift-summary-total-wallet-box'>
                            <p className='gift-summary-total-wallet-text'>
                                {commonUtil.getLabel(
                                  this.props.lables.eventAccountStatement,
                                  'accountStatement.summary.total.wallet.text',
                                )} 
                            </p>
                            <div className='gift-summary-total-wallet-box'>
                                <div style={{'--color-500': themeColor500}} className='gift-summary-total-wallet-amount'>
                                <span className='gift-summary-total-wallet-amount-span1'>{transferableAmount.currency} {transferableAmount.integerWithDot}</span>
                                {/* <span className='gift-summary-total-wallet-amount-span1'>{electronicTotalPurchasedAmount?.integerWithDot}</span> */}
                                <span className='gift-summary-total-wallet-amount-decimal'>{transferableAmount.decimal}</span>
                                </div>
                            </div>

                            </div>

                        {isBonusContainerVisible && 
                        <div className='gift-summary-total-wallet-box'>
                            <p className='gift-summary-bonus-text'>
                              {commonUtil.getLabel(
                                this.props.lables.eventAccountStatement,
                                'accountStatement.summary.bonus.percentage.accumulated.text',
                                [accountData?.bonusPercentage]
                              )}</p>
                            <div className='gift-summary-bonus-amount-box'>
                            <div className='gift-summary-bonus-amount'>
                                <span className='gift-summary-bonus-amount-span1'>{totalBonusAmount?.currency}</span>
                                <span className='gift-summary-bonus-amount-span1'>{totalBonusAmount?.integerWithDot}</span>
                                <span className='gift-summary-bonus-amount-decimal'>{totalBonusAmount?.decimal}</span>
                            </div>
                            </div>
                        </div>}


                        {((this.props.eventInfo.eventStatus === eventStatus.CLOSED)) ? ('') :
                        <>
                        <InputButton buttonAttr={cerrarMesaButton} />

                        <span className='gift-summary-close-message'>
                            {commonUtil.getLabel(
                              this.props.lables.eventAccountStatement,
                              'accountStatement.summary.close.table.event.message',
                            )} 
                        </span>
                        {initiateEventCloseProcessErrorMessageUI}
                        </>}

                        </div>

                        {
                            !isEmptyGiftRegistry ? 

                            <div className='gift-summary-items-box col-lg-7 col-md-7 col-sm-7'>
                                <div className='gift-summary-items-boxitems'>
                                    {isBonusContainerVisible &&
                                    <div style={{'--color-100': themeColor100}} className='gift-summary-items-bonusbox gift-summary-bonification-box'>
                                        <div className='gift-summary-bonus-headingbox'>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path d="M20 6.5H17.82C17.93 6.19 18 5.85 18 5.5C18 3.84 16.66 2.5 15 2.5C13.95 2.5 13.04 3.04 12.5 3.85L12 4.52L11.5 3.84C10.96 3.04 10.05 2.5 9 2.5C7.34 2.5 6 3.84 6 5.5C6 5.85 6.07 6.19 6.18 6.5H4C2.89 6.5 2.01 7.39 2.01 8.5L2 19.5C2 20.61 2.89 21.5 4 21.5H20C21.11 21.5 22 20.61 22 19.5V8.5C22 7.39 21.11 6.5 20 6.5ZM15 4.5C15.55 4.5 16 4.95 16 5.5C16 6.05 15.55 6.5 15 6.5C14.45 6.5 14 6.05 14 5.5C14 4.95 14.45 4.5 15 4.5ZM9 4.5C9.55 4.5 10 4.95 10 5.5C10 6.05 9.55 6.5 9 6.5C8.45 6.5 8 6.05 8 5.5C8 4.95 8.45 4.5 9 4.5ZM20 19.5H4V17.5H20V19.5ZM20 14.5H4V8.5H9.08L7 11.33L8.62 12.5L12 7.9L15.38 12.5L17 11.33L14.92 8.5H20V14.5Z" fill={themeColor500}/>
                                            </svg>

                                            <span className='gift-summary-bonus-heading'>{commonUtil.getLabel(
                                              this.props.lables.eventAccountStatement,
                                              'accountStatement.summary.bonus.heading',
                                            )}</span>
                                        </div>

                                        <div className='gift-summary-bonus-subheadingbox'>
                                            <span className='gift-summary-bonus-subheading'>{commonUtil.getLabel(
                                              this.props.lables.eventAccountStatement,
                                              'accountStatement.summary.bonus.sub.heading',
                                            )}</span>

                                            <div className='gift-summary-bonus-amountbox'>
                                                <span className='gift-summary-bonus-amount'>{correctTotalAmountEligibleForBonus?.currency} {correctTotalAmountEligibleForBonus?.integerWithDot} <span className='gift-summary-bonus-amount-decimal-1'>{correctTotalAmountEligibleForBonus?.decimal}</span></span>
                                            </div>
                                        </div>

                                        <div className='gift-summary-available-bonus'>
                                            <span className='Bonification-text'>{commonUtil.getLabel(
                                              this.props.lables.eventAccountStatement,
                                              'accountStatement.summary.bonus.heading.with.colon',
                                            )}</span>
                                            <span className='Bonification-text'>{totalBonusAmount?.currency} {totalBonusAmount?.integerWithDot}</span>
                                            <span className='Bonification-text2'>{totalBonusAmount?.decimal}</span>
                                        </div>

                                        <span className='Bonification-textnote'>{commonUtil.getLabel(
                                              this.props.lables.eventAccountStatement,
                                              'accountStatement.summary.bonus.textnote',
                                            )}</span>
                                    </div>}

                                    <div style={{'--color-100': themeColor100}} className='gift-summary-items-heading'>
                                        <span className='gift-summary-items-headingspan'>{commonUtil.getLabel(
                                          this.props.lables.eventAccountStatement,
                                          'accountStatement.summary.shopping.and.gift.text',
                                        )}</span>
                                    </div>
                                    <div style={{'--color-100': themeColor100}} className='gift-summary-item-box'>
                                        <div className='gift-summary-items-boxcontainer'>
                                            <div className='gift-summary-itemtype-heading-box'>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M12 6.19L17 10.69V18.5H15V12.5H9V18.5H7V10.69L12 6.19ZM12 3.5L2 12.5H5V20.5H11V14.5H13V20.5H19V12.5H22L12 3.5Z" fill={themeColor500}/>
                                                </svg>

                                                <div className='gift-summary-itemtype-heading'>
                                                    <span className='gift-summary-itemtype-headingtext'>{commonUtil.getLabel(
                                                      lables['Physical Gifts Details Page'],
                                                      'accountStatement.physical.label1'
                                                    )}</span>
                                                </div>
                                            </div>
                                                <div className='gift-summary-item-physicalgift-boxcontainer'>
                                                    <div className='gift-summary-item-physicalgift-box'>
                                                        <span className='gift-summary-item-physicalgift-text'>{commonUtil.getLabel(
                                                            this.props.lables.eventAccountStatement,
                                                            'accountStatement.physical.quantity.text',
                                                          )}</span>
                                                        <div className='gift-summary-item-physicalgift-amount-box'>
                                                            <span className='gift-summary-item-physicalgift-amount'>{itemInfo?.physicalItemInfo?.totalPurchasedItems}</span>
                                                        </div>
                                                    </div>
                                                    <div style={{'--color-100': themeColor100}} className={`gift-summary-item-bonus-section ${!isBonusContainerVisible && 'border-btm-none pb-none'}`}>
                                                        <div className='gift-summary-item-totalbonusbox'>
                                                          {isBonusContainerVisible ?
                                                            <>
                                                            <span className='gift-summary-item-totalbonustext'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.physical.amount.eligible.bonus.text',
                                                              )}
                                                            </span>
                                                            <div className='gift-summary-item-totalbonusamountbox'>
                                                                <span className='gift-summary-item-totalbonusamount'>{physicalTotalAmountEligibleForBonus?.currency} {physicalTotalAmountEligibleForBonus?.integerWithDot}</span>
                                                                <span className='gift-summary-item-totalbonusamount2'>{physicalTotalAmountEligibleForBonus?.decimal}</span>
                                                            </div>
                                                            </>
                                                            :
                                                            <>
                                                            <span className='gift-summary-item-totalbonustext'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.physical.total.amount',
                                                              )}</span>
                                                            <div className='gift-summary-item-totalbonusamountbox'>
                                                                <span className='gift-summary-item-totalbonusamount'>{physicalTotalPurchasedAmount.currency}{physicalTotalPurchasedAmount.integerWithDot}</span>
                                                                <span className='gift-summary-item-totalbonusamount2'>{physicalTotalPurchasedAmount.decimal}</span>
                                                            </div>
                                                            </>
                                                          }
                                                        </div>  
                                                        {isBonusContainerVisible &&
                                                        <div className='gift-summary-available-bonus'>
                                                            <span className='Bonification-text'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                              'accountStatement.summary.bonus.heading.with.colon',
                                                            )}</span>
                                                            <span className='Bonification-text'>{physicalTotalBonusAmount.currency} {physicalTotalBonusAmount.integerWithDot}</span>
                                                            <span className='Bonification-text2'>{physicalTotalBonusAmount.decimal}</span>
                                                        </div>}
                                                    </div>   
                                                    {isBonusContainerVisible && 
                                                    <div className='gift-summary-item-nobonusbox'>
                                                        <span className='gift-summary-item-nobonustext'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.physical.amount.not.eligible.bonus.text',
                                                              )}</span>
                                                        <div className='gift-summary-item-nobonusamountbox'>
                                                            <span className='gift-summary-item-totalbonusamount'>{physicalTotalAmountNotEligibleForBonus.currency} {physicalTotalAmountNotEligibleForBonus.integerWithDot}</span>
                                                            <span className='gift-summary-item-totalbonusamount2'>{physicalTotalAmountNotEligibleForBonus.decimal}</span>
                                                        </div>
                                                    </div>}
                                                </div>                                
                                            
                                        </div>
                             
                                        <div className='gift-summary-item-rightarrow'>
                                            {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path d="M9.70492 6L8.29492 7.41L12.8749 12L8.29492 16.59L9.70492 18L15.7049 12L9.70492 6Z" fill="#333333"/>
                                            </svg> */}
                                            <Link
                                              to={PhysicalJson.route}
                                            >
                                              <i
                                                className='icon-flecha_gruesa_derecha'
                                                aria-hidden='true'
                                              />
                                            </Link>
                                        </div>
                                        
                                    </div>

                                    <div style={{'--color-100': themeColor100}} className='gift-summary-item-electronicboxcontainer'>
                                        <div className='gift-summary-item-electronicbox'>
                                            <div className='gift-summary-itemtype-heading-box'>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12.31 11.14C10.54 10.69 9.97 10.2 9.97 9.47C9.97 8.63 10.76 8.04 12.07 8.04C13.45 8.04 13.97 8.7 14.01 9.68H15.72C15.67 8.34 14.85 7.11 13.23 6.71V5H10.9V6.69C9.39 7.01 8.18 7.99 8.18 9.5C8.18 11.29 9.67 12.19 11.84 12.71C13.79 13.17 14.18 13.86 14.18 14.58C14.18 15.11 13.79 15.97 12.08 15.97C10.48 15.97 9.85 15.25 9.76 14.33H8.04C8.14 16.03 9.4 16.99 10.9 17.3V19H13.24V17.33C14.76 17.04 15.96 16.17 15.97 14.56C15.96 12.36 14.07 11.6 12.31 11.14Z" fill={themeColor500}/>
                                                </svg>
                                                <div className='gift-summary-itemtype-heading'>
                                                    <span className='gift-summary-itemtype-headingtext'>{commonUtil.getLabel(
                                                      lables['Electronic Gifts Details Page'],
                                                      'accountStatement.electronic.label2'
                                                    )}</span>
                                                </div>
                                            </div>

                                            <div className='gift-summary-item-electronic-boxcontainer'>
                                                <div className='gift-summary-item-physicalgift-box'>
                                                    <span className='gift-summary-item-physicalgift-text'>{commonUtil.getLabel(
                                                            this.props.lables.eventAccountStatement,
                                                            'accountStatement.electronic.quantity.text',
                                                          )}</span>
                                                    <div className='gift-summary-item-physicalgift-amount-box'>
                                                        <span className='gift-summary-item-physicalgift-amount'>{itemInfo?.electronicItemInfo.totalPurchasedItems}</span>
                                                    </div>

                                                </div>

                                                <div className='gift-summary-item-bonus-section border-btm-none pb-none'>
                                                    <div className='gift-summary-item-totalbonusbox'>
                                                        {isBonusContainerVisible ?
                                                        <>
                                                        <span className='gift-summary-item-totalbonustext'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.physical.amount.eligible.bonus.text',
                                                              )}
                                                        </span>
                                                        <div className='gift-summary-item-totalbonusamountbox'>
                                                            <span className='gift-summary-item-totalbonusamount'>{electronicTotalAmountEligibleForBonus.currency} {electronicTotalAmountEligibleForBonus.integerWithDot}</span>
                                                            <span className='gift-summary-item-totalbonusamount2'>{electronicTotalAmountEligibleForBonus.decimal}</span>
                                                        </div>
                                                        </>
                                                        :
                                                        <>
                                                        <span className='gift-summary-item-totalbonustext'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.physical.total.amount',
                                                              )}</span>
                                                        <div className='gift-summary-item-totalbonusamountbox'>
                                                            <span className='gift-summary-item-totalbonusamount'>{electronicTotalPurchasedAmount.currency}{electronicTotalPurchasedAmount.integerWithDot}</span>
                                                            <span className='gift-summary-item-totalbonusamount2'>{electronicTotalPurchasedAmount.decimal}</span>
                                                        </div>
                                                        </>}
                                                    </div>  
                                                    {isBonusContainerVisible &&
                                                    <div className='gift-summary-available-bonus'>
                                                        <span className='Bonification-text'>{commonUtil.getLabel(
                                                          this.props.lables.eventAccountStatement,
                                                          'accountStatement.summary.bonus.heading.with.colon',
                                                        )}</span>
                                                        <span className='Bonification-text'>{electronicTotalBonusAmount.currency} {electronicTotalBonusAmount.integerWithDot}</span>
                                                        <span className='Bonification-text2'>{electronicTotalBonusAmount.decimal}</span>
                                                    </div>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='gift-summary-item-rightarrow'>
                                            {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path d="M9.70492 6L8.29492 7.41L12.8749 12L8.29492 16.59L9.70492 18L15.7049 12L9.70492 6Z" fill="#333333"/>
                                            </svg> */}
                                            <Link
                                              to={ElectronicJson.route}
                                            >
                                              <i
                                                className='icon-flecha_gruesa_derecha'
                                                aria-hidden='true'
                                              />
                                            </Link>
                                        </div>
                                    </div>

                                    <div className='gift-summary-item-box2'>
                                        <div className='gift-summary-items-boxcontainer'>
                                            <div className='gift-summary-miscomprasitem-headerbox'>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M22 10.8703L19.26 9.28033C19.5 9.07033 19.73 8.80033 19.9 8.50033C20.73 7.07033 20.24 5.23033 18.8 4.40033C17.94 3.90033 16.93 3.90033 16.08 4.26033L16.09 4.25033L15.21 4.64033L15.1 3.68033L15.09 3.69033C15 2.78033 14.47 1.90033 13.61 1.40033C12.17 0.57533 10.34 1.07033 9.5 2.50033C9.33 2.80033 9.22 3.13033 9.16 3.45033L6.41 1.87033C5.45 1.32033 4.23 1.64033 3.68 2.60033L2.18 5.20033C1.9 5.68033 2.07 6.29033 2.55 6.56033L4.28 7.56033L8.5 10.0003H2V20.0003C2 21.1103 2.9 22.0003 4 22.0003H20C21.11 22.0003 22 21.1103 22 20.0003V14.8703L22.73 13.6003C23.28 12.6403 22.96 11.4203 22 10.8703ZM16.44 6.50033C16.71 6.00033 17.33 5.86033 17.8 6.13033C18.28 6.41033 18.45 7.00033 18.17 7.50033C17.89 8.00033 17.28 8.14033 16.8 7.87033C16.33 7.59033 16.16 7.00033 16.44 6.50033ZM14.07 8.60033L21 12.6003L20 14.3303L13.07 10.3303L14.07 8.60033ZM11 20.0003H4V12.0003H11V20.0003ZM11.34 9.33033L4.41 5.33033L5.41 3.60033L12.34 7.60033L11.34 9.33033ZM11.61 4.87033C11.13 4.59033 10.97 4.00033 11.24 3.50033C11.5 3.00033 12.13 2.86033 12.61 3.13033C13.09 3.41033 13.25 4.00033 12.97 4.50033C12.7 5.00033 12.09 5.14033 11.61 4.87033ZM13 20.0003V12.6003L20 16.6403V20.0003H13Z" fill={themeColor500}/>
                                                </svg>

                                                <span className='gift-summary-miscomprasitem-header gift-summary-miscomprasitem-headertext'>{commonUtil.getLabel(
                                                  this.props.lables.eventAccountStatement,
                                                  'accountStatement.personal.header.text',
                                                )}</span>
                                            </div>
                                            <div className='gift-summary-item-electronic-boxcontainer'>
                                                <div className='gift-summary-item-physicalgift-box'>
                                                    <span className='gift-summary-item-physicalgift-text'>{commonUtil.getLabel(
                                                            this.props.lables.eventAccountStatement,
                                                            'accountStatement.personal.quantity.text',
                                                          )}</span>
                                                    <div className='gift-summary-item-physicalgift-amount-box'>
                                                        <span className='gift-summary-item-physicalgift-amount'>{itemInfo?.personalItemInfo.totalPurchasedItems}</span>
                                                    </div>
                                                </div>

                                                <div style={{'--color-100': themeColor100}} className={`gift-summary-item-bonus-section ${!isBonusContainerVisible && 'border-btm-none pb-none'}`}>
                                                    <div className='gift-summary-item-electronic-totalbonusbox'>
                                                       {isBonusContainerVisible ?
                                                        <>
                                                        <span className='gift-summary-item-physicalgift-text'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.physical.amount.eligible.bonus.text',
                                                              )}</span>
                                                        <div className='gift-summary-item-totalbonusamountbox'>
                                                            <span className='gift-summary-item-totalbonusamount'>{personalTotalAmountEligibleForBonus.currency} {personalTotalAmountEligibleForBonus.integerWithDot}</span>
                                                            <span className='gift-summary-item-totalbonusamount2'>{personalTotalAmountEligibleForBonus.decimal}</span>
                                                        </div>
                                                        </>
                                                        :
                                                        <>
                                                        <span className='gift-summary-item-physicalgift-text'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.physical.total.amount',
                                                              )}</span>
                                                        <div className='gift-summary-item-totalbonusamountbox'>
                                                            <span className='gift-summary-item-totalbonusamount'>{personalTotalPurchasedAmount.currency}{personalTotalPurchasedAmount.integerWithDot}</span>
                                                            <span className='gift-summary-item-totalbonusamount2'>{personalTotalPurchasedAmount.decimal}</span>
                                                        </div>
                                                        </>}
                                                    </div>
                                                    {isBonusContainerVisible &&
                                                    <div className='gift-summary-item-physicalgift-amount-box'>
                                                        <span className='Bonification-text'>{commonUtil.getLabel(
                                                          this.props.lables.eventAccountStatement,
                                                          'accountStatement.summary.bonus.heading.with.colon',
                                                        )}</span>
                                                        <span className='Bonification-text'>{personalTotalBonusAmount.currency} {personalTotalBonusAmount.integerWithDot}</span>
                                                        <span className='Bonification-text2'>{personalTotalBonusAmount.decimal}</span>
                                                    </div>}
                                                </div>

                                                {isBonusContainerVisible &&
                                                <div className='gift-summary-miscomprasitem-nobonusbox'>
                                                    <span className='gift-summary-item-nobonustext'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.physical.amount.not.eligible.bonus.text',
                                                              )}</span>
                                                    <div className='gift-summary-miscomprasitem-nobonusamountbox'>
                                                        <span className='gift-summary-item-nobonustext'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.physical.total.text',
                                                              )}</span>
                                                        <span className='gift-summary-miscomprasitem-nobonusamount'>{personalTotalAmountNotEligibleForBonus.currency} {personalTotalAmountNotEligibleForBonus.integerWithDot}</span>
                                                        <span className='gift-summary-miscomprasitem-nobonusamountbox-2'>{personalTotalAmountNotEligibleForBonus.decimal}</span>
                                                    </div>
                                                </div>}
                                            </div>
                                        </div>
                                        <div className='gift-summary-item-rightarrow'>
                                            {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path d="M9.70492 6L8.29492 7.41L12.8749 12L8.29492 16.59L9.70492 18L15.7049 12L9.70492 6Z" fill="#333333"/>
                                            </svg> */}
                                            <Link
                                              to={PersonalJson.route}
                                            >
                                              <i
                                                className='icon-flecha_gruesa_derecha'
                                                aria-hidden='true'
                                              />
                                            </Link>
                                        </div>
                                        
                                    </div>
                                </div>

                                <div className={`gift-summary-withdraw-container ${(accountData?.eventMessage &&
                                 accountData?.eventMessage.indexOf('Muchas') > -1)  ? 'gift-summary-withdraw-container-muchas' : ''}`}>
                                {((accountData?.eventMessage == null) || (accountData?.eventMessage &&
                                 accountData?.eventMessage.indexOf('Muchas') == -1)) &&
                                    <div className='gift-summary-withdraw-box'>
                                        <div className='gift-summary-withdrawheading-box'>
                                            <span className='gift-summary-bonus-heading'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.withdraw.balance.question.text',
                                                              )}</span>
                                            {/* <HelpTooltip isTopToolTip={false} bonusPercentage={bonusPercentage} lables={this.props.lables}/> */}
                                            <div className="iconHelp inLine iconHelp-pl iconHelpWrapper">
                                                <img src={commonUtil.getAssetURL() + '/images/help.svg'} width={'24'} height={'24'} alt="icon_help" className="icon_help icon_help_gl" onClick={() => { this.handlePopUpCoOwner('helpPopup'); }} />
                                                <div className="tooltip-backdrop" />
                                                <div id="helpPopup" className="popover bottom bottom-gls helpIconCssEmail helpIconEventCss">
                                                    <div className="arrow" />
                                                    <div className="popover-content">
                                                        {commonUtil.getLabel(
                                                          this.props.lables.eventAccountStatement,
                                                          'accountStatement.summary.tooltip.withdrawal.text',
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='gift-summary-withdrawavailable-box'>
                                            <span className='gift-summary-bonus-subheading'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.withdraw.balance.available.text',
                                                              )}</span>
                                            <div className='gift-summary-withdrawavailable-amount-box'>
                                                <span className='gift-summary-miscomprasitem-nobonusamountbox'>{transferableAmount.currency} {transferableAmount.integerWithDot}</span>
                                                <span className='gift-summary-miscomprasitem-nobonusamountbox-2 ml-37'>{transferableAmount.decimal}</span>
                                            </div>
                                        </div>

                                        {this.props.eventInfo.eventStatus === eventStatus.CLOSED ? ('') : (
                                          <InputButton buttonAttr={partialTransferenceButton} />
                                        )}
                                        <div className='gift-summary-withdraw-message'>
                                            <span className=''>{isBonusContainerVisible ? commonUtil.getLabel(
                                              this.props.lables.eventAccountStatement,
                                              'accountStatement.withdraw.balance.percentage.message.text',
                                              [accountData?.bonusPercentage]
                                            ) : commonUtil.getLabel(
                                              this.props.lables.eventAccountStatement,
                                              'accountStatement.withdraw.balance.without.percentage.message.text'
                                            )}</span>
                                        </div>
                                    </div>}
                                    <div style={{'--color-100': themeColor100}} className={`gift-summary-withdraw-made-container ${(accountData?.eventMessage &&
                                        accountData?.eventMessage.indexOf('Muchas') > -1)  ? 'gift-summary-withdraw-made-container-muchas' : ''}`}>
                                        <div className='gift-summary-withdraw-made-box'>
                                            <div className='gift-summary-withdraw-made-heading-box'>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z" fill={themeColor500}/>
                                                </svg>
                                                <span className='gift-summary-items-headingspan'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.withdrawal.made.text',
                                                              )}</span>
                                            </div>
                                            <div className='gift-summary-withdraw-made-amount-box'>
                                                <div className='gift-summary-total-withdrawed-amount-box'>
                                                    <span className='gift-summary-bonus-subheading'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.total.withdrawn.text',
                                                              )}</span>
                                                    <div className='gift-summary-item-physicalgift-amount-box'>
                                                        <span className='gift-summary-total-withdrawed-amount'>{totalTransferredAmount.currency} {totalTransferredAmount.integerWithDot}</span>
                                                        <span className='gift-summary-total-withdrawed-amount-2'>{totalTransferredAmount.decimal}</span>
                                                    </div>
                                                </div>
                                                {isBonusContainerVisible &&
                                                <div className='gift-summary-item-physicalgift-amount-box'>
                                                    <span className='gift-summary-bonus-claimed-text'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.discounted.bonus.text',
                                                              )}</span>
                                                    <span className='gift-summary-bonus-claimed-amount'>{totalBonusLost.currency} {totalBonusLost.integerWithDot}</span>
                                                    <span className='gift-summary-bonus-claimed-amount-2'>{totalBonusLost.decimal}</span>
                                                </div>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>                             
                            : 
                            <div className='gift-summary-no-items-box col-lg-7 col-md-7 col-sm-7'>
                                <div className={`gift-summary-no-items ${(accountData?.eventMessage &&
                                 accountData?.eventMessage.indexOf('Muchas') > -1) && 'visibility-hidden'}`}>
                                    <div className='gift-summary-no-items-heading'>
                                        <span>{commonUtil.getLabel(
                                        this.props.lables.eventAccountStatement,
                                          'accountStatement.no.gift.purchases.text',
                                        )}</span>
                                    </div>
                                </div>

                                <div className='gift-summary-no-items-image'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="160" height="160" viewBox="0 0 160 160" fill="none">
                                    <circle cx="80.0004" cy="80.0004" r="79.932" fill="#F5F5F5"/>
                                    <path d="M146.215 52.0612L40.627 17.7128C37.2831 16.625 33.6904 18.454 32.6026 21.7979L10.7258 89.048C9.63799 92.3919 11.4669 95.9846 14.8109 97.0724L120.399 131.421C123.743 132.509 127.335 130.68 128.423 127.336L150.3 60.0855C151.388 56.7416 149.559 53.149 146.215 52.0612Z" fill="#333333" fill-opacity="0.45"/>
                                    <path d="M145.456 51.818L39.8682 17.4696C36.5243 16.3818 32.9316 18.2108 31.8438 21.5547L9.967 88.8048C8.8792 92.1488 10.7081 95.7414 14.0521 96.8292L119.64 131.178C122.984 132.265 126.577 130.436 127.664 127.092L149.541 59.8424C150.629 56.4984 148.8 52.9058 145.456 51.818Z" fill="#333333" fill-opacity="0.45"/>
                                    <path opacity="0.2" d="M145.456 51.818L39.8682 17.4696C36.5243 16.3818 32.9316 18.2108 31.8438 21.5547L9.967 88.8048C8.8792 92.1488 10.7081 95.7414 14.0521 96.8292L119.64 131.178C122.984 132.265 126.577 130.436 127.664 127.092L149.541 59.8424C150.629 56.4984 148.8 52.9058 145.456 51.818Z" fill="white"/>
                                    <path opacity="0.2" d="M54.588 110.016L37.4434 104.433L98.0869 36.4062L115.238 41.9825L54.588 110.016Z" fill="white"/>
                                    <path opacity="0.2" d="M70.2114 115.094L60.2041 111.843L120.854 43.8096L130.862 47.0681L70.2114 115.094Z" fill="white"/>
                                    <path d="M73.654 28.2038L72.8955 27.957L46.9255 107.79L47.6839 108.037L73.654 28.2038Z" fill="white"/>
                                    <path d="M138.807 93.9577L139.054 93.1992L20.7469 54.7133L20.5002 55.4718L138.807 93.9577Z" fill="white"/>
                                    <path d="M60.2951 68.2556C60.2456 68.2539 60.1974 68.2392 60.1555 68.2129C60.1135 68.1865 60.0794 68.1495 60.0565 68.1056C58.3863 64.554 55.0187 59.4617 51.4535 54.0695C45.3659 44.8598 39.6193 36.1614 41.4121 33.8845C42.012 33.1278 43.2936 33.121 45.3319 33.8845C54.3916 37.1976 62.5037 55.3988 60.5609 68.0442C60.5517 68.1006 60.525 68.1526 60.4846 68.1929C60.4443 68.2333 60.3923 68.26 60.336 68.2692L60.2951 68.2556ZM42.8505 33.8436C42.6643 33.8229 42.4758 33.8453 42.2997 33.9091C42.1235 33.973 41.9644 34.0765 41.8348 34.2117C40.2737 36.1886 46.4498 45.5279 51.8966 53.7764C55.2164 58.8005 58.3659 63.5655 60.1519 67.0899C61.5834 54.6898 53.8189 37.5384 45.1546 34.3685C44.421 34.067 43.6423 33.8896 42.8505 33.8436Z" fill="white"/>
                                    <path d="M27.7094 90.0342C27.056 90.0437 26.4052 89.9517 25.7802 89.7615C23.7351 89.0798 22.7057 87.287 22.7943 84.3761C22.8693 81.9698 24.3486 79.5566 27.1913 77.1979C34.7922 70.8786 50.9006 66.2908 60.3353 67.7292C60.3796 67.7339 60.4218 67.7502 60.4577 67.7766C60.4936 67.8029 60.522 67.8383 60.5398 67.8791C60.5601 67.9193 60.5707 67.9637 60.5707 68.0087C60.5707 68.0537 60.5601 68.0981 60.5398 68.1382C54.8612 76.6048 36.51 90.0342 27.7094 90.0342ZM56.47 67.9882C47.0899 67.9882 34.0968 72.1466 27.5321 77.6001C24.8053 79.8633 23.3942 82.147 23.3261 84.4171C23.2443 87.062 24.1236 88.6981 25.9438 89.2844C33.197 91.6089 53.6478 77.0684 59.8376 68.22C58.7216 68.0673 57.5965 67.9898 56.47 67.9882Z" fill="white"/>
                                    <path d="M67.5277 92.4351H67.3572C64.8009 92.3601 62.8103 91.4807 61.4333 89.8242C57.7726 85.4273 58.8361 76.1903 60.1176 67.8259C60.1248 67.7687 60.1508 67.7156 60.1915 67.6748C60.2323 67.6341 60.2854 67.6081 60.3426 67.601C60.3983 67.5919 60.4554 67.6017 60.5048 67.6289C60.5542 67.6561 60.5931 67.699 60.6153 67.7509C61.7469 70.1573 63.0557 72.6728 64.3101 75.1132C68.1412 82.5096 71.4474 88.9039 69.8795 91.3921C69.6142 91.7578 69.2569 92.0469 68.8439 92.23C68.4309 92.4132 67.9768 92.4839 67.5277 92.4351ZM60.513 68.7598C59.3064 76.7561 58.4679 85.4068 61.8764 89.4833C63.1648 91.0376 64.9781 91.8352 67.4118 91.9034C68.4411 91.9375 69.1092 91.6784 69.4568 91.1126C70.8611 88.8766 67.4663 82.3051 63.867 75.3518C62.6808 73.1636 61.5219 70.9208 60.4789 68.7462L60.513 68.7598Z" fill="#333333" fill-opacity="0.45"/>
                                    <path d="M68.3314 68.6913C65.6439 68.6991 62.9596 68.5055 60.3011 68.1119C60.262 68.1047 60.2249 68.0895 60.192 68.0672C60.1592 68.0449 60.1313 68.016 60.1102 67.9824C60.0948 67.9457 60.0869 67.9063 60.0869 67.8665C60.0869 67.8267 60.0948 67.7873 60.1102 67.7506C61.5418 64.0967 66.2795 60.5724 71.365 59.3726C75.7824 58.3296 79.7771 59.1681 82.6198 61.7312C84.0581 63.0265 83.9831 64.0899 83.6696 64.7511C82.4221 67.3552 75.5301 68.6913 68.3314 68.6913ZM60.7101 67.6347C70.4856 69.0663 81.754 67.5256 83.1719 64.5262C83.5196 63.7968 83.206 62.9924 82.2448 62.1198C79.518 59.6793 75.7074 58.8886 71.4672 59.8907C66.6886 61.0223 62.2371 64.2467 60.7101 67.6347Z" fill="white"/>
                                    <path d="M56.8866 98.0995C56.205 98.0995 55.4824 97.5064 54.6371 96.293C50.3492 90.1578 53.3146 74.9219 60.1997 67.7368C60.238 67.6957 60.2886 67.6681 60.3439 67.6583C60.3993 67.6485 60.4563 67.6569 60.5064 67.6823C60.5582 67.708 60.6001 67.7498 60.6259 67.8015C60.6518 67.8532 60.6601 67.9118 60.6496 67.9686C60.1315 70.9613 60.002 75.6922 59.8588 80.7027C59.5793 90.7849 59.2453 97.4383 57.2002 98.0518C57.0982 98.081 56.9928 98.097 56.8866 98.0995ZM60.0293 68.7457C53.7031 76.0058 51.0582 90.1714 55.1074 96.0135C55.9186 97.1724 56.6003 97.711 57.0843 97.561C58.9113 97.0156 59.1294 88.3513 59.3612 80.7095C59.4566 76.1217 59.5793 71.7793 60.0293 68.7457Z" fill="white"/>
                                    <path d="M83.9544 76.9464C76.2717 76.9464 65.2078 72.9108 60.2041 68.0844C60.1708 68.054 60.1463 68.0151 60.1331 67.972C60.1199 67.9288 60.1185 67.8829 60.1291 67.839C60.1359 67.7951 60.1549 67.754 60.1838 67.7203C60.2127 67.6865 60.2504 67.6616 60.2927 67.6481C68.2617 64.5532 88.2422 64.4033 92.0597 69.4137C93.0959 70.7771 92.9255 72.4064 91.5553 74.2333C90.4236 75.7398 88.3922 76.626 85.5154 76.8578C85.011 76.926 84.4929 76.9464 83.9544 76.9464ZM60.879 68.0162C66.2985 72.9381 78.085 76.9601 85.4745 76.3534C88.2013 76.1352 90.0964 75.324 91.1258 73.9402C92.3392 72.3245 92.4892 70.9203 91.6371 69.7614C88.0922 65.085 68.8003 65.1667 60.879 68.0162Z" fill="white"/>
                                    <path d="M60.2939 68.255C60.2559 68.2645 60.2161 68.2645 60.1781 68.255C60.1271 68.2284 60.0858 68.1864 60.06 68.135C60.0343 68.0836 60.0255 68.0254 60.0349 67.9686C61.0915 61.9016 64.6636 49.4606 70.6284 45.7999C71.3689 45.3115 72.2084 44.9934 73.0866 44.8684C73.9648 44.7435 74.8598 44.8148 75.7071 45.0773C76.1645 45.1703 76.5878 45.3865 76.9314 45.7024C77.275 46.0184 77.5258 46.4222 77.6567 46.8702C78.5293 50.4832 70.8398 57.975 64.7045 63.9944C63.1366 65.5282 61.6573 66.9734 60.4848 68.2004C60.4303 68.2419 60.3622 68.2614 60.2939 68.255ZM73.9278 45.3091C72.848 45.3237 71.7942 45.6427 70.8875 46.2294C66.0338 49.2152 62.2709 59.0316 60.7098 67.212C61.7732 66.1281 63.0207 64.901 64.3364 63.6194C70.0763 58.0091 77.9362 50.3264 77.1318 47.0065C77.0228 46.6471 76.8169 46.3247 76.5367 46.0746C76.2565 45.8244 75.9129 45.6563 75.5435 45.5886C75.0286 45.4166 74.491 45.3224 73.9483 45.3091H73.9278Z" fill="white"/>
                                    <path d="M55.0324 69.5705C53.1423 69.5688 51.2694 69.2127 49.5106 68.5207C46.2181 67.2051 44.0571 64.8805 43.3754 61.9696C43.0277 60.4631 43.5663 59.8019 44.0571 59.5155C46.7839 57.9817 55.2369 62.7945 60.4177 67.7981C60.4475 67.8256 60.4703 67.8596 60.4845 67.8975C60.4988 67.9354 60.5039 67.976 60.4995 68.0163C60.4962 68.0548 60.484 68.0921 60.4639 68.1252C60.4438 68.1583 60.4163 68.1864 60.3837 68.2072C58.7639 69.1566 56.9089 69.6292 55.0324 69.5705ZM45.3796 59.7541C45.0212 59.7374 44.6646 59.8125 44.3434 59.9723C43.8253 60.2654 43.6617 60.8994 43.8935 61.8469C44.5206 64.5737 46.5862 66.7824 49.7083 68.0299C53.1986 69.4274 57.3978 69.3933 59.8656 67.9481C55.0733 63.4421 48.4404 59.7541 45.3796 59.7541Z" fill="white"/>
                                    </svg>
                                </div>
                                <div className={`gift-summary-no-items-text-box ${(accountData?.eventMessage &&
                                 accountData?.eventMessage.indexOf('Muchas') > -1) && 'visibility-hidden'}`}>
                                    <div className='gift-summary-no-items-text'>
                                        <span>{commonUtil.getLabel(
                                        this.props.lables.eventAccountStatement,
                                          'accountStatement.no.gift.purchases.text.message',
                                        )}</span>
                                    </div>
                                </div>
                            </div>
                        }
                        
                    </div>
                    </div>

                    <ModalPopover
                      ref={(system) => (this.valeSystemModal = system)}
                      isModal='true'
                    >
                      <button
                        className='close closeClass'
                        id='closeModal'
                        type='button'
                        data-dismiss='modal'
                        aria-label='Close'
                      >
                        <span
                          className='closeModal'
                          aria-hidden='true'
                        >
                          ×
                        </span>
                      </button>
                      <h4>
                        <strong>
                          {commonUtil.getLabel(
                            lables['Event Account Landing page – Vales system down'],
                            'accountStatement.valesystemdown.message1'
                          )}
                        </strong>
                      </h4>
                      <ValeSystemModal
                        lables={this.props.lables}
                        startTime={this._StartTime}
                        endTime={this._EndTime}
                      />
                    </ModalPopover>

                    <ModalPopover
                      ref={(system) => (this.temporaryClosingModal = system)}
                      isModal='true'
                      outerClass={' gift-summary-temporary-close-modal-dialog '}
                      innerClass={' gift-summary-temporary-close-modal-content '}
                      customBodyClass={' gift-summary-temporary-close-modal-body '}
                    >
                      <div style={webCloseModal}>
                      <button
                        className='close'
                        id='closeModal'
                        type='button'
                        data-dismiss='modal'
                        aria-label='Close'
                        style={webCloseBtn}
                      >
                        <span
                          className='closeModal'
                          aria-hidden='true'
                          style={webCloseSpan}
                        >
                          ×
                        </span>
                      </button>
                      <h4>{commonUtil.getLabel(
                       this.props.lables.eventAccountStatement,
                         'accountStatement.gift.table.closure.web.modal.header',
                       )}</h4>
                      </div>
                      <TemporaryClosingModal
                        lables={this.props.lables}
                        temporaryModal={this.onTemporaryClosingModalAcceptor}
                        eventId={this.eventId}
                        isInitialClosure={this.state.isInitialClosure}
                      />
                    </ModalPopover> 
                </>
                :
                <>                    
                    <div className='gift-summary-wap' >
                        {/* <div className='gift-summary-wap-box'> */}
                        <span className='gift-summary-span-wap'>
                          { (this.props.eventInfo.eventStatus === eventStatus.CLOSED) ?
                            commonUtil.getLabel(
                                this.props.lables.eventAccountStatement,
                                'accountStatement.summary.mesa.de.regalos.cerrada.text'
                               ) :
                               accountData?.eventMessage && accountData?.eventMessage.indexOf('Muchas') > -1
                             ? commonUtil.getLabel(
                              this.props.lables.eventAccountStatement,
                              'accountStatement.summary.mesa.de.regalos.cerrada.text',
                            )
                            : accountData?.enableEventClosure?.toString() === 'true'
                            ? commonUtil.getLabel(
                              this.props.lables.eventAccountStatement,
                              'accountStatement.gift.table.event.close.table.text',
                            )
                            : (this.eventDaysleft <= 0) ? commonUtil.getLabel(
                              this.props.lables.eventAccountStatement,
                              'accountStatement.gift.table.event.close.table.text',
                            ) :<>{noOfDaysLeftLabelParts[0]}
                              <strong>{this.eventDaysleft} días</strong>
                              {noOfDaysLeftLabelParts[1]}</>
                          }
                          </span>
                            <div className='gift-summary-icon1-wap'>
                                <svg className={`${isAdminProcessStatus ? 'icon-disabled' : 'cursor-pointer'}`} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                  onClick={() => {
                                    if (!isAdminProcessStatus) {
                                      this.getStatementDetailsForDownload(isBonusContainerVisible);
                                    }
                                  }}
                                >
                                    <path d="M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM17 11L15.59 9.59L13 12.17V4H11V12.17L8.41 9.59L7 11L12 16L17 11Z" fill="#333333"/>
                                </svg>
                                <svg className={`${isAdminProcessStatus ? 'icon-disabled' : 'cursor-pointer'}`} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                  onClick={() => {
                                    if (!isAdminProcessStatus) {
                                      this.getStatementDetailsForSendMail(isBonusContainerVisible);
                                    }
                                  }}
                                >
                                    <path d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 10.99L4 6H20ZM20 18H4V8L12 13L20 8V18Z" fill="#333333"/>
                                </svg>
                            </div>
                        {/* </div> */}
                    </div>

                    <div className='gift-summary-header-container-wap'>
                        <div className='gift-summary-amount-container-wap'>
                            <div className='gift-summary-totalamount-header-wap'>
                                {/* <div className='gift-summary-totalamount-box-wap'> */}
                                
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M22 12V20C22 20.5304 21.7893 21.0391 21.4142 21.4142C21.0391 21.7893 20.5304 22 20 22H4C3.46957 22 2.96086 21.7893 2.58579 21.4142C2.21071 21.0391 2 20.5304 2 20V12C1.73478 12 1.48043 11.8946 1.29289 11.7071C1.10536 11.5196 1 11.2652 1 11V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H6.17C6.06 5.69 6 5.35 6 5C6 4.20435 6.31607 3.44129 6.87868 2.87868C7.44129 2.31607 8.20435 2 9 2C10 2 10.88 2.5 11.43 3.24V3.23L12 4L12.57 3.23V3.24C13.12 2.5 14 2 15 2C15.7956 2 16.5587 2.31607 17.1213 2.87868C17.6839 3.44129 18 4.20435 18 5C18 5.35 17.94 5.69 17.83 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V11C23 11.2652 22.8946 11.5196 22.7071 11.7071C22.5196 11.8946 22.2652 12 22 12ZM4 20H11V12H4V20ZM20 20V12H13V20H20ZM9 4C8.73478 4 8.48043 4.10536 8.29289 4.29289C8.10536 4.48043 8 4.73478 8 5C8 5.26522 8.10536 5.51957 8.29289 5.70711C8.48043 5.89464 8.73478 6 9 6C9.26522 6 9.51957 5.89464 9.70711 5.70711C9.89464 5.51957 10 5.26522 10 5C10 4.73478 9.89464 4.48043 9.70711 4.29289C9.51957 4.10536 9.26522 4 9 4ZM15 4C14.7348 4 14.4804 4.10536 14.2929 4.29289C14.1054 4.48043 14 4.73478 14 5C14 5.26522 14.1054 5.51957 14.2929 5.70711C14.4804 5.89464 14.7348 6 15 6C15.2652 6 15.5196 5.89464 15.7071 5.70711C15.8946 5.51957 16 5.26522 16 5C16 4.73478 15.8946 4.48043 15.7071 4.29289C15.5196 4.10536 15.2652 4 15 4ZM3 8V10H11V8H3ZM13 8V10H21V8H13Z" fill={themeColor500}/>
                                    </svg>
                                    <div className='gift-summary-grand-total-wap'>
                                        <span className='gift-summary-grand-total-text-wap'>
                                        {commonUtil.getLabel(
                                          this.props.lables.eventAccountStatement,
                                          'accountStatement.summary.grand.total.text',
                                        )}        
                                        </span>
                                    </div>
                                    <div style={{marginTop:"3px"}}>
                                      <HelpTooltip isTopToolTip={true} bonusPercentage={bonusPercentage} lables={this.props.lables}/>
                                    </div>
                                </div>
                                <div className='gift-summary-total-purchases-wap'>
                                    <span className='gift-summary-total-purchases-text-wap'>
                                    {commonUtil.getLabel(
                                      this.props.lables.eventAccountStatement,
                                      'accountStatement.summary.total.purchase.text',
                                    )}
                                    </span>
                                    <div className='gift-summary-total-purchases-amount-wap' /*style={{fontWeight: 300, lineHeight: '20.8px', fontSize: '16px'}}*/>
                                    <div style={{'--color-500': themeColor500}} className='gift-summary-total-purchases-text-wap gift-summary-total-purchases-text2-wap'>
                                        <span>{totalPurchasedAmount?.currency}</span>
                                        <span>{totalPurchasedAmount?.integerWithDot}</span>
                                        <span className='gift-summary-total-purchases-text-wap-span2'>{totalPurchasedAmount?.decimal}</span>
                                    </div>
                                    </div>
                                    
                                </div>

                                <div className='gift-summary-total-wallet-heading-wap'>
                                    <p className='gift-summary-total-wallet-text-wap'>
                                        {commonUtil.getLabel(
                                          this.props.lables.eventAccountStatement,
                                          'accountStatement.summary.total.wallet.text',
                                        )} 
                                    </p>
                                    <div className='gift-summary-total-wallet-body-wap'>
                                        <div style={{'--color-500': themeColor500}} className='gift-summary-total-wallet-amountbody-wap'>
                                        <span className='gift-summary-total-wallet-amountbody-wap-span1'>{transferableAmount.currency} {transferableAmount.integerWithDot}</span>
                                        {/* <span className='gift-summary-total-wallet-amountbody-wap-span1'>{electronicTotalPurchasedAmount.integerWithDot}</span> */}
                                        <span className='gift-summary-total-wallet-amountbody-wap-span2'>{transferableAmount.decimal}</span>
                                        </div>
                                    </div>

                                    </div>

                                {isBonusContainerVisible &&
                                <div className='gift-summary-total-wallet-box-wap'>
                                    <p className='gift-summary-bonus-text-wap'>{commonUtil.getLabel(
                                      this.props.lables.eventAccountStatement,
                                      'accountStatement.summary.bonus.percentage.accumulated.text',
                                      [accountData?.bonusPercentage]
                                    )}</p>
                                    <div className='gift-summary-bonus-amount-box-wap'>
                                    <div className='gift-summary-bonus-amount-wap'>
                                        <span className='gift-summary-total-wallet-amountbody-wap-span1'>{totalBonusAmount?.currency}</span>
                                        <span className='gift-summary-total-wallet-amountbody-wap-span1'>{totalBonusAmount?.integerWithDot}</span>
                                        <span className='gift-summary-bonus-amount-wap-span2'>{totalBonusAmount?.decimal}</span>
                                    </div>
                                    </div>
                                </div>}

                                {((this.props.eventInfo.eventStatus === eventStatus.CLOSED)) ? ('') :
                                <>
                                <InputButton buttonAttr={cerrarMesaButton} />

                                <span className='gift-summary-close-message-wap'>
                                    {commonUtil.getLabel(
                                      this.props.lables.eventAccountStatement,
                                      'accountStatement.summary.close.table.event.message',
                                    )}
                                </span>
                                {initiateEventCloseProcessErrorMessageUI}
                                </>
                                }

                            </div>
                        
                            {!isEmptyGiftRegistry ? 
                                <div className='gift-summary-items-box-wap'>
                                    <div className='gift-summary-items-boxitems-wap'>
                                        {isBonusContainerVisible &&
                                        <div style={{'--color-100': themeColor100}} className='gift-summary-bonification-box-wap'>
                                            <div className='gift-summary-items-bonusbox-wap'>
                                                <div className='gift-summary-bonus-headingbox-wap'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                        <path d="M20 6.5H17.82C17.93 6.19 18 5.85 18 5.5C18 3.84 16.66 2.5 15 2.5C13.95 2.5 13.04 3.04 12.5 3.85L12 4.52L11.5 3.84C10.96 3.04 10.05 2.5 9 2.5C7.34 2.5 6 3.84 6 5.5C6 5.85 6.07 6.19 6.18 6.5H4C2.89 6.5 2.01 7.39 2.01 8.5L2 19.5C2 20.61 2.89 21.5 4 21.5H20C21.11 21.5 22 20.61 22 19.5V8.5C22 7.39 21.11 6.5 20 6.5ZM15 4.5C15.55 4.5 16 4.95 16 5.5C16 6.05 15.55 6.5 15 6.5C14.45 6.5 14 6.05 14 5.5C14 4.95 14.45 4.5 15 4.5ZM9 4.5C9.55 4.5 10 4.95 10 5.5C10 6.05 9.55 6.5 9 6.5C8.45 6.5 8 6.05 8 5.5C8 4.95 8.45 4.5 9 4.5ZM20 19.5H4V17.5H20V19.5ZM20 14.5H4V8.5H9.08L7 11.33L8.62 12.5L12 7.9L15.38 12.5L17 11.33L14.92 8.5H20V14.5Z" fill={themeColor500}/>
                                                    </svg>

                                                    <span className='gift-summary-bonus-heading-wap gift-summary-bonus-headingtext-wap'>{commonUtil.getLabel(
                                                        this.props.lables.eventAccountStatement,
                                                        'accountStatement.summary.bonus.heading',
                                                      )}
                                                    </span>
                                                </div>

                                                <div className='gift-summary-bonus-subheadingdiv-wap'>
                                                    <div className='gift-summary-bonus-subheadingbox-wap'>
                                                        <div className='gift-summary-bonus-subheading-wap'>
                                                            <span className='gift-summary-bonus-subheading-text-wap'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                              'accountStatement.summary.bonus.sub.heading',
                                                            )}</span>
                                                        </div>                                                    
                                                    </div>
                                                    <div className='gift-summary-bonus-amountbox-wap'>
                                                        <span className='gift-summary-bonus-text-wap'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.physical.total.text',
                                                              )}</span>
                                                        <div className='gift-summary-bonus1-amount-box-wap'>
                                                            <span className='gift-summary-bonus1-amount-wap'>{correctTotalAmountEligibleForBonus?.currency}{correctTotalAmountEligibleForBonus?.integerWithDot}</span>
                                                            <span class="gift-summary-bonus1-amount1-wap">{correctTotalAmountEligibleForBonus?.decimal}</span>
                                                        </div>
                                                    </div>

                                                    <div className='gift-summary-bonus1-amount-box-wap'>
                                                        <span className='Bonification-text-wap'>{commonUtil.getLabel(
                                                          this.props.lables.eventAccountStatement,
                                                          'accountStatement.summary.bonus.heading.with.colon',
                                                        )} {totalBonusAmount?.currency} {totalBonusAmount?.integerWithDot}</span>
                                                        <span class="Bonification-text1-wap">{totalBonusAmount?.decimal}</span>
                                                    </div>

                                                    <span className='Bonification-textnote-wap'>{commonUtil.getLabel(
                                                      this.props.lables.eventAccountStatement,
                                                      'accountStatement.summary.bonus.textnote.wap',
                                                    )}</span>
                                                </div>
                                            </div>
                                        </div>}

                                        <div style={{'--color-100': themeColor100}} className='gift-summary-items-heading-wap'>
                                            <span className='gift-summary-items-headingspan-wap'>{commonUtil.getLabel(
                                              this.props.lables.eventAccountStatement,
                                              'accountStatement.summary.shopping.and.gift.text',
                                            )}</span>
                                        </div>
                                        <div style={{'--color-100': themeColor100}} className='gift-summary-bonification-box-wap'>
                                            <div className='gift-summary-items-boxcontainer-wap'>
                                                <div className='gift-summary-bonus-headingbox-wap'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 25 24" fill="none">
                                                        <path d="M12.5 6.19L17.5 10.69V18.5H15.5V12.5H9.5V18.5H7.5V10.69L12.5 6.19ZM12.5 3.5L2.5 12.5H5.5V20.5H11.5V14.5H13.5V20.5H19.5V12.5H22.5L12.5 3.5Z" fill={themeColor500}/>
                                                    </svg>

                                                    <div className='gift-summary-itemtype-heading-wap'>
                                                        <span className='gift-summary-itemtype-headingtext-wap'>{commonUtil.getLabel(
                                                          lables['Physical Gifts Details Page'],
                                                          'accountStatement.physical.label1'
                                                        )}</span>
                                                    </div>
                                                </div>
                                                <div className='gift-summary-item-physicalgift-boxcontainer-wap'>
                                                    <div className='gift-summary-item-physicalgift-box-wap'>
                                                        <span className='gift-summary-item-physicalgift-text-wap'>{commonUtil.getLabel(
                                                            this.props.lables.eventAccountStatement,
                                                            'accountStatement.physical.quantity.text',
                                                          )}</span>
                                                        <div className='gift-summary-item-physicalgift-amount-box-wap'>
                                                            <span className='gift-summary-item-physicalgift-amount-wap'>{itemInfo?.physicalItemInfo.totalPurchasedItems}</span>
                                                        </div>
                                                    </div>
                                                    <div style={{'--color-100': themeColor100}} className={`gift-summary-item-bonus-section-wap ${!isBonusContainerVisible && 'border-btm-none'}`}>
                                                      {isBonusContainerVisible ?
                                                        <>
                                                        <div className='gift-summary-item-physicalgift-box-wap'>
                                                            <span className='gift-summary-item-physicalgift-text-wap'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.physical.amount.eligible.bonus.text2',
                                                              )}</span>
                                                        </div> 
                                                        <div className='gift-summary-item-physicalgift-amount-box-wap'>
                                                            <span className='gift-summary-item-physicalgift-text-wap'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.physical.total.text',
                                                              )} </span>
                                                            <span className='gift-summary-item-totalbonusamountwap'>{physicalTotalAmountEligibleForBonus?.currency} {physicalTotalAmountEligibleForBonus?.integerWithDot}</span>
                                                            <span className='gift-summary-item-totalbonusamountwap1'>{physicalTotalAmountEligibleForBonus?.decimal}</span>
                                                        </div>                                                    
                                                        <div className='gift-summary-bonus-subheadingbox-wap'>
                                                            <span className='Bonification-text-wap'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                              'accountStatement.summary.bonus.heading.with.colon',
                                                            )} {physicalTotalBonusAmount.currency}{physicalTotalBonusAmount.integerWithDot}</span>
                                                            <span className='Bonification-text1-wap'>{physicalTotalBonusAmount.decimal}</span>
                                                        </div>
                                                        </>
                                                        :
                                                        <>
                                                        <div className='gift-summary-item-physicalgift-box-wap'>
                                                            <span className='gift-summary-item-physicalgift-text-wap'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                              'accountStatement.summary.regalos.recibidos.total.text',
                                                            )}</span>
                                                        </div> 
                                                        <div className='gift-summary-item-physicalgift-amount-box-wap'>
                                                            <span className='gift-summary-item-physicalgift-text-wap'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.physical.total.text',
                                                              )} </span>
                                                            <span className='gift-summary-item-totalbonusamountwap'>{physicalTotalPurchasedAmount.currency} {physicalTotalPurchasedAmount.integerWithDot}</span>
                                                            <span className='gift-summary-item-totalbonusamountwap1'>{physicalTotalPurchasedAmount.decimal}</span>
                                                        </div>     
                                                        </>
                                                      }
                                                    </div>   
                                                    {isBonusContainerVisible && 
                                                    <>
                                                    <div className='gift-summary-item-physicalgift-box-wap'>
                                                        <span className='gift-summary-item-physicalgift-text-wap'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.physical.amount.not.eligible.bonus.text',
                                                              )}</span>
                                                    </div>  
                                                    <div className='gift-summary-item-physicalgift-amount-box-wap'>
                                                        <span className='gift-summary-item-physicalgift-text-wap'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.physical.total.text',
                                                              )} </span>
                                                        <span className='gift-summary-item-totalbonusamountwap'>{physicalTotalAmountNotEligibleForBonus.currency} {physicalTotalAmountNotEligibleForBonus.integerWithDot}</span>
                                                        <span className='gift-summary-item-totalbonusamountwap1'>{physicalTotalAmountNotEligibleForBonus.decimal}</span>
                                                    </div>
                                                    </>}
                                                    
                                                </div>                                
                                                
                                            </div>
                                            <div className='gift-summary-item-rightarrow-wap'>
                                                {/* <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                                                    <path d="M10.2049 6L8.79492 7.41L13.3749 12L8.79492 16.59L10.2049 18L16.2049 12L10.2049 6Z" fill="#333333"/>
                                                </svg> */}
                                                <Link
                                                  to={PhysicalJson.route}
                                                  onClick={PhysicalJson.onClickHandler}
                                                >
                                                  <i
                                                    className='icon-flecha_gruesa_derecha'
                                                    aria-hidden='true'
                                                  />
                                                </Link>
                                            </div>
                                        </div>

                                        <div style={{'--color-100': themeColor100}} className='gift-summary-bonification-box-wap'>
                                            <div className='gift-summary-item-electronicbox-wap'>
                                                <div className='gift-summary-bonus-headingbox-wap'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 25 24" fill="none">
                                                        <path d="M12.5 2C6.98 2 2.5 6.48 2.5 12C2.5 17.52 6.98 22 12.5 22C18.02 22 22.5 17.52 22.5 12C22.5 6.48 18.02 2 12.5 2ZM12.5 20C8.09 20 4.5 16.41 4.5 12C4.5 7.59 8.09 4 12.5 4C16.91 4 20.5 7.59 20.5 12C20.5 16.41 16.91 20 12.5 20ZM12.81 11.14C11.04 10.69 10.47 10.2 10.47 9.47C10.47 8.63 11.26 8.04 12.57 8.04C13.95 8.04 14.47 8.7 14.51 9.68H16.22C16.17 8.34 15.35 7.11 13.73 6.71V5H11.4V6.69C9.89 7.01 8.68 7.99 8.68 9.5C8.68 11.29 10.17 12.19 12.34 12.71C14.29 13.17 14.68 13.86 14.68 14.58C14.68 15.11 14.29 15.97 12.58 15.97C10.98 15.97 10.35 15.25 10.26 14.33H8.54C8.64 16.03 9.9 16.99 11.4 17.3V19H13.74V17.33C15.26 17.04 16.46 16.17 16.47 14.56C16.46 12.36 14.57 11.6 12.81 11.14Z" fill={themeColor500}/>
                                                    </svg>
                                                    <div className='gift-summary-itemtype-heading-wap'>
                                                        <span className='gift-summary-itemtype-headingtext-wap'>{commonUtil.getLabel(
                                                          lables['Electronic Gifts Details Page'],
                                                          'accountStatement.electronic.label2'
                                                        )}</span>
                                                    </div>
                                                </div>

                                                <div className='gift-summary-item-physicalgift-boxcontainer-wap'>
                                                    <div className='gift-summary-item-physicalgift-box-wap'>
                                                        <span className='gift-summary-item-physicalgift-text-wap'>{commonUtil.getLabel(
                                                            this.props.lables.eventAccountStatement,
                                                            'accountStatement.electronic.quantity.text',
                                                          )}</span>
                                                        <div className='gift-summary-item-physicalgift-amount-box-wap'>
                                                            <span className='gift-summary-item-physicalgift-amount-wap'>{itemInfo?.electronicItemInfo.totalPurchasedItems}</span>
                                                        </div>

                                                    </div>

                                                    <div className='gift-summary-item-bonus-section-wap border-btm-none'>
                                                      {isBonusContainerVisible ?
                                                        <>
                                                        <div className='gift-summary-item-physicalgift-box-wap'>
                                                            <span className='gift-summary-item-physicalgift-text-wap'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.physical.amount.eligible.bonus.text',
                                                              )}</span>
                                                        </div> 
                                                        <div className='gift-summary-item-physicalgift-amount-box-wap'>
                                                            <span className='gift-summary-item-physicalgift-text-wap'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.physical.total.text',
                                                              )} </span>
                                                            <span className='gift-summary-item-totalbonusamountwap'>{electronicTotalAmountEligibleForBonus.currency} {electronicTotalAmountEligibleForBonus.integerWithDot}</span>
                                                            <span className='gift-summary-item-totalbonusamountwap1'>{electronicTotalAmountEligibleForBonus.decimal}</span>
                                                        </div>
                                                        <div className='gift-summary-bonus-subheadingbox-wap'>
                                                            <span className='Bonification-text-wap'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                              'accountStatement.summary.bonus.heading.with.colon',
                                                            )} {electronicTotalBonusAmount.currency}{electronicTotalBonusAmount.integerWithDot}</span>
                                                            <span className='Bonification-text1-wap'>{electronicTotalBonusAmount.decimal}</span>
                                                        </div>
                                                        </> 
                                                        :
                                                        <>
                                                        <div className='gift-summary-item-physicalgift-box-wap'>
                                                            <span className='gift-summary-item-physicalgift-text-wap'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                              'accountStatement.electronic.regalos.electronico.total.text',
                                                            )}</span>
                                                        </div> 
                                                        <div className='gift-summary-item-physicalgift-amount-box-wap'>
                                                            <span className='gift-summary-item-physicalgift-text-wap'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.physical.total.text',
                                                              )} </span>
                                                            <span className='gift-summary-item-totalbonusamountwap'>{electronicTotalPurchasedAmount.currency} {electronicTotalPurchasedAmount.integerWithDot}</span>
                                                            <span className='gift-summary-item-totalbonusamountwap1'>{electronicTotalPurchasedAmount.decimal}</span>
                                                        </div>
                                                        </>
                                                      }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='gift-summary-item-rightarrow-wap'>
                                                {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M9.70492 6L8.29492 7.41L12.8749 12L8.29492 16.59L9.70492 18L15.7049 12L9.70492 6Z" fill="#333333"/>
                                                </svg> */}
                                                <Link
                                                  to={ElectronicJson.route}
                                                  onClick={ElectronicJson.onClickHandler}
                                                >
                                                  <i
                                                    className='icon-flecha_gruesa_derecha'
                                                    aria-hidden='true'
                                                  />
                                                </Link>
                                            </div>
                                        </div>

                                        <div className='gift-summary-bonification-box-wap border-btm-none'>
                                            <div className='gift-summary-items-boxcontainer-wap'>
                                                <div className='gift-summary-bonus-headingbox-wap'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                        <path d="M22 10.8703L19.26 9.28033C19.5 9.07033 19.73 8.80033 19.9 8.50033C20.73 7.07033 20.24 5.23033 18.8 4.40033C17.94 3.90033 16.93 3.90033 16.08 4.26033L16.09 4.25033L15.21 4.64033L15.1 3.68033L15.09 3.69033C15 2.78033 14.47 1.90033 13.61 1.40033C12.17 0.57533 10.34 1.07033 9.5 2.50033C9.33 2.80033 9.22 3.13033 9.16 3.45033L6.41 1.87033C5.45 1.32033 4.23 1.64033 3.68 2.60033L2.18 5.20033C1.9 5.68033 2.07 6.29033 2.55 6.56033L4.28 7.56033L8.5 10.0003H2V20.0003C2 21.1103 2.9 22.0003 4 22.0003H20C21.11 22.0003 22 21.1103 22 20.0003V14.8703L22.73 13.6003C23.28 12.6403 22.96 11.4203 22 10.8703ZM16.44 6.50033C16.71 6.00033 17.33 5.86033 17.8 6.13033C18.28 6.41033 18.45 7.00033 18.17 7.50033C17.89 8.00033 17.28 8.14033 16.8 7.87033C16.33 7.59033 16.16 7.00033 16.44 6.50033ZM14.07 8.60033L21 12.6003L20 14.3303L13.07 10.3303L14.07 8.60033ZM11 20.0003H4V12.0003H11V20.0003ZM11.34 9.33033L4.41 5.33033L5.41 3.60033L12.34 7.60033L11.34 9.33033ZM11.61 4.87033C11.13 4.59033 10.97 4.00033 11.24 3.50033C11.5 3.00033 12.13 2.86033 12.61 3.13033C13.09 3.41033 13.25 4.00033 12.97 4.50033C12.7 5.00033 12.09 5.14033 11.61 4.87033ZM13 20.0003V12.6003L20 16.6403V20.0003H13Z" fill={themeColor500}/>
                                                    </svg>
                                                    <div className='gift-summary-itemtype-heading-wap'>
                                                        <span className='gift-summary-itemtype-headingtext-wap'>{commonUtil.getLabel(
                                                          this.props.lables.eventAccountStatement,
                                                          'accountStatement.personal.header.text',
                                                        )}</span>
                                                    </div>
                                                </div>
                                                <div className='gift-summary-item-physicalgift-boxcontainer-wap'>
                                                    <div className='gift-summary-item-physicalgift-box-wap'>
                                                        <span className='gift-summary-item-physicalgift-text-wap'>{commonUtil.getLabel(
                                                            this.props.lables.eventAccountStatement,
                                                            'accountStatement.personal.quantity.text',
                                                          )}</span>
                                                        <div className='gift-summary-item-physicalgift-amount-box-wap'>
                                                            <span className='gift-summary-item-physicalgift-amount-wap'>{itemInfo?.personalItemInfo.totalPurchasedItems}</span>
                                                        </div>
                                                    </div>

                                                    <div style={{'--color-100': themeColor100}} className={`gift-summary-item-bonus-section-wap ${!isBonusContainerVisible && 'border-btm-none'}`}>
                                                      {isBonusContainerVisible ?
                                                        <>
                                                        <div className='gift-summary-item-physicalgift-box-wap'>
                                                            <span className='gift-summary-item-physicalgift-text-wap'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.physical.amount.eligible.bonus.text2',
                                                              )}</span>
                                                        </div>
                                                        <div className='gift-summary-item-physicalgift-amount-box-wap'>
                                                            <span className='gift-summary-item-physicalgift-text-wap'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.physical.total.text',
                                                              )} </span>
                                                            <span className='gift-summary-item-totalbonusamountwap'>{personalTotalAmountEligibleForBonus.currency} {personalTotalAmountEligibleForBonus.integerWithDot}</span>
                                                            <span className='gift-summary-item-totalbonusamountwap1'>{personalTotalAmountEligibleForBonus.decimal}</span>
                                                        </div>
                                                        <div className='gift-summary-bonus-subheadingbox-wap'>
                                                            <span className='Bonification-text-wap'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                              'accountStatement.summary.bonus.heading.with.colon',
                                                            )} {personalTotalBonusAmount.currency}{personalTotalBonusAmount.integerWithDot}</span>
                                                            <span className='Bonification-text1-wap'>{personalTotalBonusAmount.decimal}</span>
                                                        </div>
                                                        </>
                                                        :
                                                        <>
                                                        <div className='gift-summary-item-physicalgift-box-wap'>
                                                            <span className='gift-summary-item-physicalgift-text-wap'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                              'accountStatement.personal.compras.personales.total.text',
                                                            )}</span>
                                                        </div>
                                                        <div className='gift-summary-item-physicalgift-amount-box-wap'>
                                                            <span className='gift-summary-item-physicalgift-text-wap'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.physical.total.text',
                                                              )} </span>
                                                            <span className='gift-summary-item-totalbonusamountwap'>{personalTotalPurchasedAmount.currency} {personalTotalPurchasedAmount.integerWithDot}</span>
                                                            <span className='gift-summary-item-totalbonusamountwap1'>{personalTotalPurchasedAmount.decimal}</span>
                                                        </div>
                                                        </>
                                                      }
                                                    </div>

                                                    {isBonusContainerVisible &&
                                                    <>
                                                    <div className='gift-summary-item-physicalgift-box-wap'>
                                                        <span className='gift-summary-item-physicalgift-text-wap'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.physical.amount.not.eligible.bonus.text',
                                                              )}</span>
                                                    </div>
                                                    <div className='gift-summary-item-physicalgift-amount-box-wap'>
                                                        <span className='gift-summary-item-physicalgift-text-wap'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.physical.total.text',
                                                              )} </span>
                                                        <span className='gift-summary-item-totalbonusamountwap'>{personalTotalAmountNotEligibleForBonus.currency} {personalTotalAmountNotEligibleForBonus.integerWithDot}</span>
                                                        <span className='gift-summary-item-totalbonusamountwap1'>{personalTotalAmountNotEligibleForBonus.decimal}</span>
                                                    </div>
                                                    </>
                                                    }
                                                </div>
                                            </div>
                                            <div className='gift-summary-item-rightarrow-wap'>
                                                {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M9.70492 6L8.29492 7.41L12.8749 12L8.29492 16.59L9.70492 18L15.7049 12L9.70492 6Z" fill="#333333"/>
                                                </svg> */}
                                                <Link
                                                  to={PersonalJson.route}
                                                  onClick={PersonalJson.onClickHandler}
                                                >
                                                  <i
                                                    className='icon-flecha_gruesa_derecha'
                                                    aria-hidden='true'
                                                  />
                                                </Link>
                                            </div>
                                            
                                        </div>
                                    </div>

                                    <div className='gift-summary-withdraw-container-wap'>
                                        <div className='gift-summary-withdraw-box-wap'>
                                            <div className='gift-summary-withdrawheading-box-wap'>
                                                <span className='gift-summary-itemtype-headingtext-wap'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.withdraw.balance.question.text',
                                                              )}</span>
                                                <HelpTooltip isTopToolTip={false} bonusPercentage={bonusPercentage} lables={this.props.lables}/>           
                                            </div>
                                            <div className='gift-summary-item-bonus-section-wap border-btm-none'>
                                                <span className='gift-summary-item-physicalgift-text-wap'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.withdraw.balance.available.text.with.colon',
                                                              )}</span>
                                                <div className='gift-summary-withdrawavailable-amount-box-wap'>
                                                    <span className='gift-summary-item-totalbonusamountwap'>{transferableAmount.currency} {transferableAmount.integerWithDot}</span>
                                                    <span className='gift-summary-item-totalbonusamountwap1'>{transferableAmount.decimal}</span>
                                                </div>
                                            </div>
                                            {/* <button className='gift-summary-remove-button-box-wap'>
                                                <span className='gift-summary-withdraw-cancel-wap'>Retirar ahora</span>
                                            </button> */}
                                            {this.props.eventInfo.eventStatus === eventStatus.CLOSED ? ('') : (
                                              <InputButton buttonAttr={partialTransferenceButton} />
                                            )}
                                            <div className='gift-summary-withdraw-message-wap'>
                                                <span className='gift-summary-withdraw-message-text-wap'>{isBonusContainerVisible ? commonUtil.getLabel(
                                                  this.props.lables.eventAccountStatement,
                                                  'accountStatement.withdraw.balance.percentage.message.text',
                                                  [accountData?.bonusPercentage]
                                                ) : commonUtil.getLabel(
                                                  this.props.lables.eventAccountStatement,
                                                  'accountStatement.withdraw.balance.without.percentage.message.text'
                                                )}</span>
                                            </div>
                                        </div>
                                        <div style={{'--color-100': themeColor100}} className='gift-summary-withdraw-made-container-wap'>
                                            <div className='gift-summary-withdraw-made-box-wap'>
                                                <div className='gift-summary-withdraw-made-heading-box-wap'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                        <path d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z" fill={themeColor500}/>
                                                    </svg>
                                                    <span className='gift-summary-items-headingspan-wap2'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.withdrawal.made.text',
                                                              )}</span>
                                                </div>
                                                <div className='gift-summary-withdraw-made-amount-box-wap'>
                                                    <div className='gift-summary-total-withdrawed-amount-box-wap'>
                                                        <span className='gift-summary-bonus-subheading-text-wap'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.total.withdrawn.text',
                                                              )}</span>
                                                        <div className='gift-summary-bonus-subheadingbox-wap'>
                                                            <span className='gift-summary-withdraw-cancel-wap'>{totalTransferredAmount.currency} {totalTransferredAmount.integerWithDot}</span>
                                                            <span className='gift-summary-withdraw-cancel-wap1'>{totalTransferredAmount.decimal}</span>
                                                        </div>
                                                    </div>
                                                    {isBonusContainerVisible &&
                                                    <div className='gift-summary-total-withdrawed-amount-box-wap'>
                                                        <span className='gift-summary-bonusdiscount-wap'>{commonUtil.getLabel(
                                                              this.props.lables.eventAccountStatement,
                                                                'accountStatement.discounted.bonus.text',
                                                              )}</span>
                                                        <span className='gift-summary-bonus-claimed-amount-wap'>{totalBonusLost.currency} {totalBonusLost.integerWithDot}</span>
                                                        <span className='gift-summary-bonus-claimed-amount-wap1'>{totalBonusLost.decimal}</span>
                                                    </div>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>                             
                                :
                                <>
                                    <div className={`gift-summary-no-items-box-wap ${(accountData?.eventMessage &&
                                 accountData?.eventMessage.indexOf('Muchas') > -1) && 'display-none'}`}>
                                    {/* <div className='gift-summary-no-items'> */}
                                        <div className='gift-summary-no-items-heading-wap' style={{width: '355px'}}>
                                            <span>{commonUtil.getLabel(
                                        this.props.lables.eventAccountStatement,
                                          'accountStatement.no.gift.purchases.text',
                                        )}</span>
                                        </div>
                                    </div>

                                    <div className={`gift-summary-no-items-image-wap ${(accountData?.eventMessage &&
                                        accountData?.eventMessage.indexOf('Muchas') > -1) && 'display-none'}`}>
                                        <div style={{width: '106.576px', height: '106.576px'}}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="108" height="108" viewBox="0 0 108 108" fill="none">
                                                <circle cx="53.9999" cy="53.9999" r="53.288" fill="#F5F5F5"/>
                                                <path d="M98.1433 35.3736L27.7513 12.4747C25.522 11.7495 23.127 12.9688 22.4018 15.1981L7.81719 60.0315C7.09199 62.2608 8.31129 64.6559 10.5406 65.3811L80.9326 88.28C83.1619 89.0052 85.5569 87.7859 86.2821 85.5566L100.867 40.7232C101.592 38.4939 100.373 36.0988 98.1433 35.3736Z" fill="#333333" fill-opacity="0.45"/>
                                                <path d="M97.6375 35.212L27.2455 12.3131C25.0162 11.5879 22.6211 12.8072 21.8959 15.0365L7.31133 59.8699C6.58613 62.0992 7.80543 64.4943 10.0347 65.2195L80.4267 88.1184C82.656 88.8436 85.0511 87.6243 85.7763 85.395L100.361 40.5616C101.086 38.3323 99.8668 35.9372 97.6375 35.212Z" fill="#333333" fill-opacity="0.45"/>
                                                <path opacity="0.2" d="M97.6375 35.212L27.2455 12.3131C25.0162 11.5879 22.6211 12.8072 21.8959 15.0365L7.31133 59.8699C6.58613 62.0992 7.80543 64.4943 10.0347 65.2195L80.4267 88.1184C82.656 88.8436 85.0511 87.6243 85.7763 85.395L100.361 40.5616C101.086 38.3323 99.8668 35.9372 97.6375 35.212Z" fill="white"/>
                                                <path opacity="0.2" d="M37.0587 74.0104L25.6289 70.2884L66.0579 24.9375L77.4922 28.655L37.0587 74.0104Z" fill="white"/>
                                                <path opacity="0.2" d="M47.4743 77.3962L40.8027 75.2285L81.2363 29.873L87.9078 32.0454L47.4743 77.3962Z" fill="white"/>
                                                <path d="M49.7693 19.4697L49.2637 19.3052L31.9503 72.527L32.4559 72.6915L49.7693 19.4697Z" fill="white"/>
                                                <path d="M93.2047 63.3054L93.3691 62.7998L14.4979 37.1426L14.3334 37.6482L93.2047 63.3054Z" fill="white"/>
                                                <path d="M40.8634 46.17C40.8304 46.169 40.7983 46.1591 40.7703 46.1416C40.7424 46.124 40.7196 46.0993 40.7043 46.0701C39.5909 43.7023 37.3458 40.3075 34.969 36.7127C30.9106 30.5729 27.0795 24.7739 28.2747 23.256C28.6747 22.7516 29.5291 22.747 30.8879 23.256C36.9277 25.4647 42.3358 37.5989 41.0406 46.0292C41.0345 46.0667 41.0167 46.1014 40.9898 46.1283C40.9629 46.1552 40.9282 46.173 40.8906 46.1791L40.8634 46.17ZM29.2337 23.2288C29.1095 23.2149 28.9839 23.2299 28.8664 23.2724C28.749 23.315 28.643 23.384 28.5565 23.4742C27.5158 24.7921 31.6332 31.0182 35.2644 36.5173C37.4776 39.8666 39.5772 43.0433 40.7679 45.3929C41.7223 37.1262 36.546 25.6919 30.7697 23.5787C30.2807 23.3777 29.7616 23.2594 29.2337 23.2288Z" fill="white"/>
                                                <path d="M19.1396 60.69C18.704 60.6963 18.2702 60.635 17.8534 60.5082C16.49 60.0537 15.8038 58.8585 15.8629 56.9179C15.9129 55.3137 16.8991 53.7049 18.7942 52.1324C23.8614 47.9196 34.6004 44.861 40.8902 45.8199C40.9197 45.8231 40.9479 45.834 40.9718 45.8515C40.9958 45.8691 41.0146 45.8927 41.0265 45.9199C41.0401 45.9467 41.0472 45.9763 41.0472 46.0063C41.0472 46.0363 41.0401 46.0659 41.0265 46.0926C37.2408 51.737 25.0067 60.69 19.1396 60.69ZM38.3134 45.9926C32.06 45.9926 23.3979 48.7649 19.0214 52.4006C17.2036 53.9094 16.2628 55.4318 16.2174 56.9452C16.1628 58.7085 16.7491 59.7992 17.9625 60.1901C22.798 61.7398 36.4319 52.0461 40.5584 46.1471C39.8144 46.0453 39.0643 45.9937 38.3134 45.9926Z" fill="white"/>
                                                <path d="M45.6851 62.2897H45.5715C43.8673 62.2397 42.5402 61.6535 41.6222 60.5491C39.1817 57.6179 39.8907 51.4599 40.7451 45.8836C40.7499 45.8455 40.7672 45.8101 40.7943 45.7829C40.8215 45.7557 40.8569 45.7384 40.8951 45.7336C40.9322 45.7276 40.9703 45.7341 41.0032 45.7523C41.0362 45.7704 41.0621 45.799 41.0768 45.8336C41.8313 47.4379 42.7038 49.1148 43.54 50.7418C46.0941 55.6727 48.2983 59.9356 47.253 61.5944C47.0761 61.8382 46.838 62.0309 46.5626 62.153C46.2873 62.2751 45.9845 62.3223 45.6851 62.2897ZM41.0087 46.5062C40.2043 51.8371 39.6453 57.6042 41.9176 60.3219C42.7765 61.3581 43.9854 61.8898 45.6078 61.9353C46.2941 61.958 46.7395 61.7853 46.9712 61.4081C47.9074 59.9174 45.6442 55.5364 43.2446 50.9009C42.4539 49.4421 41.6813 47.9469 40.986 46.4971L41.0087 46.5062Z" fill="#333333" fill-opacity="0.45"/>
                                                <path d="M46.221 46.4609C44.4293 46.4661 42.6397 46.337 40.8674 46.0746C40.8413 46.0698 40.8166 46.0597 40.7947 46.0448C40.7728 46.0299 40.7542 46.0107 40.7401 45.9883C40.7299 45.9638 40.7246 45.9375 40.7246 45.911C40.7246 45.8845 40.7299 45.8582 40.7401 45.8337C41.6945 43.3978 44.853 41.0482 48.2433 40.2484C51.1882 39.5531 53.8514 40.1121 55.7465 41.8208C56.7054 42.6843 56.6554 43.3933 56.4464 43.8341C55.6147 45.5701 51.0201 46.4609 46.221 46.4609ZM41.1401 45.7565C47.6571 46.7108 55.1693 45.6838 56.1146 43.6841C56.3464 43.1979 56.1373 42.6616 55.4966 42.0799C53.6787 40.4529 51.1383 39.9257 48.3115 40.5938C45.1257 41.3482 42.1581 43.4978 41.1401 45.7565Z" fill="white"/>
                                                <path d="M38.5911 66.0663C38.1366 66.0663 37.6549 65.671 37.0914 64.862C34.2328 60.7718 36.2097 50.6146 40.7998 45.8246C40.8253 45.7971 40.8591 45.7788 40.896 45.7722C40.9329 45.7656 40.9709 45.7713 41.0043 45.7882C41.0388 45.8053 41.0667 45.8332 41.084 45.8677C41.1012 45.9021 41.1067 45.9412 41.0997 45.9791C40.7543 47.9742 40.668 51.1281 40.5726 54.4684C40.3862 61.19 40.1635 65.6255 38.8002 66.0345C38.7321 66.054 38.6619 66.0647 38.5911 66.0663ZM40.6862 46.4972C36.4688 51.3372 34.7054 60.7809 37.4049 64.6757C37.9458 65.4483 38.4002 65.8073 38.7229 65.7073C39.9408 65.3437 40.0863 59.5675 40.2408 54.473C40.3044 51.4145 40.3862 48.5195 40.6862 46.4972Z" fill="white"/>
                                                <path d="M56.6362 51.9646C51.5144 51.9646 44.1385 49.2742 40.8027 46.0566C40.7805 46.0363 40.7642 46.0104 40.7554 45.9816C40.7466 45.9528 40.7457 45.9222 40.7528 45.893C40.7573 45.8637 40.7699 45.8363 40.7892 45.8138C40.8084 45.7913 40.8336 45.7747 40.8618 45.7657C46.1745 43.7025 59.4948 43.6025 62.0398 46.9428C62.7306 47.8517 62.617 48.9379 61.7035 50.1559C60.9491 51.1602 59.5948 51.751 57.677 51.9055C57.3407 51.951 56.9953 51.9646 56.6362 51.9646ZM41.2527 46.0111C44.8656 49.2924 52.7233 51.9737 57.6497 51.5692C59.4675 51.4238 60.7309 50.883 61.4172 49.9604C62.2261 48.8834 62.3261 47.9472 61.758 47.1746C59.3948 44.057 46.5335 44.1115 41.2527 46.0111Z" fill="white"/>
                                                <path d="M40.8626 46.17C40.8373 46.1763 40.8107 46.1763 40.7854 46.17C40.7514 46.1523 40.7238 46.1243 40.7067 46.09C40.6896 46.0557 40.6837 46.0169 40.6899 45.9791C41.3943 41.9344 43.7757 33.6404 47.7523 31.2C48.2459 30.8743 48.8056 30.6622 49.3911 30.5789C49.9765 30.4956 50.5732 30.5432 51.138 30.7182C51.443 30.7802 51.7252 30.9243 51.9543 31.1349C52.1833 31.3456 52.3505 31.6148 52.4378 31.9135C53.0195 34.3221 47.8932 39.3167 43.803 43.3296C42.7577 44.3521 41.7716 45.3156 40.9899 46.1336C40.9535 46.1613 40.9081 46.1743 40.8626 46.17ZM49.9519 30.8727C49.232 30.8825 48.5294 31.0952 47.925 31.4863C44.6892 33.4768 42.1806 40.0211 41.1398 45.4746C41.8488 44.752 42.6805 43.934 43.5576 43.0796C47.3842 39.3394 52.6241 34.2176 52.0879 32.0044C52.0152 31.7648 51.8779 31.5498 51.6911 31.383C51.5043 31.2163 51.2753 31.1042 51.029 31.0591C50.6857 30.9444 50.3273 30.8816 49.9655 30.8727H49.9519Z" fill="white"/>
                                                <path d="M37.3549 47.047C36.0949 47.0459 34.8463 46.8085 33.6738 46.3471C31.4787 45.47 30.0381 43.9203 29.5836 41.9798C29.3518 40.9754 29.7108 40.5346 30.0381 40.3437C31.8559 39.3212 37.4912 42.5297 40.9452 45.8654C40.965 45.8837 40.9802 45.9064 40.9897 45.9317C40.9992 45.9569 41.0026 45.984 40.9997 46.0108C40.9975 46.0366 40.9893 46.0614 40.9759 46.0835C40.9625 46.1056 40.9442 46.1242 40.9224 46.1381C39.8426 46.7711 38.606 47.0861 37.3549 47.047ZM30.9197 40.5028C30.6808 40.4916 30.443 40.5417 30.2289 40.6482C29.8835 40.8436 29.7745 41.2663 29.929 41.898C30.3471 43.7158 31.7241 45.1883 33.8055 46.0199C36.1324 46.9516 38.9319 46.9289 40.577 45.9654C37.3822 42.9614 32.9602 40.5028 30.9197 40.5028Z" fill="white"/>
                                            </svg>
                                        </div>
                                        
                                    </div>
                                    <div className={`gift-summary-no-items-text-box-wap ${(accountData?.eventMessage &&
                                 accountData?.eventMessage.indexOf('Muchas') > -1) && 'display-none'}`}>
                                        <div className='gift-summary-no-items-text-wap' style={{width: '240px'}}>
                                            <span>{commonUtil.getLabel(
                                            this.props.lables.eventAccountStatement,
                                              'accountStatement.no.gift.purchases.text.message',
                                            )}</span>
                                        </div>
                                    </div>
                                </>                           
                            }
                    </div>


                    <ModalPopover
                      ref={system => (this.valeSystemModal = system)}
                      isModal="true"
                    >
                      <button
                        className="close closeClass"
                        id="closeModal"
                        type="button"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span className="closeModal" aria-hidden="true">
                          ×
                        </span>
                      </button>
                      <h4 className="closeModal-h4">
                        <strong>
                          {commonUtil.getLabel(
                            this.props.lables[
                              'Event Account Landing page – Vales system down'
                            ],
                            'accountStatement.valesystemdown.message1',
                          )}
                        </strong>
                      </h4>
                      <ValeSystemModal
                        lables={this.props.lables}
                        startTime={this._StartTime}
                        endTime={this._EndTime}
                      />
                    </ModalPopover>

                    <ModalPopover
                      modalId="modalWAP"
                      ref={system => (this.temporaryClosingModal = system)}
                      isModal="true"
                    >
                      <button
                        className="close closeClass"
                        id="closeModal"
                        type="button"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span className="closeModal" aria-hidden="true">
                          ×
                        </span>
                      </button>
                      <h4 className="closeModal-h4">{commonUtil.getLabel(
                       this.props.lables.eventAccountStatement,
                         'accountStatement.gift.table.closure.wap.modal.header',
                       )}</h4>
                      <TemporaryClosingModal
                        lables={this.props.lables}
                        temporaryModal={this.onTemporaryClosingModalAcceptor}
                        eventId={this.eventId}
                        isInitialClosure={this.state.isInitialClosure}
                      />
                    </ModalPopover>
                </>
            }  
        </>
 );
}
}


const mapStateToProps = state => ({
  accountStatus: state.accountSummary && state.accountSummary.accountStatus,
});

const matchDispatchToProps = dispatch => bindActionCreators(
  {
    getEventAccountStatementDetails, 
  }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(GiftListSummary);
